/* Common part for Static and WebGL viewers */
/* Depends on sculpteo3DViewerCommonTransform3D */
/* Depends on sculpteo3DViewerCommonLayer */

// Class for scene objects, made of:
// - a Mesh model,
//   composed of "vbos" for webgl: arrays of positions,faces,normas, and mesh material (none,color,texture) used for rendering
//   composed of a single dict of positions, faces and normals for 2d canvas
// - a transform matrix to place it in the world
// - a material type, currently "global" to apply the 3D printing material, or "mesh" to use the materials of the mesh at all times
function Sculpteo3DViewerCommonNode(
  model,
  transform,
  material,
  group,
  opacity,
  proto,
  instance,
  drawmode
) {
  this.model = model;
  this.transform = transform
    ? transform
    : Sculpteo3DViewerCommonTransform3D.identity;
  this.material = material || "global";

  if (typeof group != "undefined") {
    this.group = group;
  }

  this.opacity = typeof opacity != "undefined" ? opacity : 1.0;

  if (!this.nb_layers) {
    this.nb_layers = 0;
  }

  if (proto) {
    this.proto = proto;
  }

  if (instance) {
    this.instance = instance;
  }

  if (drawmode) {
    this.drawmode = drawmode;
  } else {
    this.drawmode = Sculpteo3DViewerCommon.DRAWMODE_FLAT;
  }
}

function Sculpteo3DViewerCommon() {
  this.$imageDiv = $();
  this.$canvas = $();
  this.$ruler = $();
  this.materialMap = {};
  this.mouse_disabled = false;
}

Sculpteo3DViewerCommon.INTERACTIVE_CLICK = 1 << 0;
Sculpteo3DViewerCommon.INTERACTIVE_MOUSEENTER = 1 << 1;
Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE = 1 << 2;
Sculpteo3DViewerCommon.INTERACTIVE_MOUSEDOWN = 1 << 3;
Sculpteo3DViewerCommon.INTERACTIVE_MOUSEUP = 1 << 4;
Sculpteo3DViewerCommon.INTERACTIVE_MOUSEMOVE = 1 << 5;

Sculpteo3DViewerCommon.INTERACTIVE_SELECT = 1 << 16;
Sculpteo3DViewerCommon.INTERACTIVE_ROTATE = 1 << 17;
Sculpteo3DViewerCommon.INTERACTIVE_PAN = 1 << 18;
Sculpteo3DViewerCommon.INTERACTIVE_SCALE = 1 << 19;
Sculpteo3DViewerCommon.INTERACTIVE_MOVE =
  Sculpteo3DViewerCommon.INTERACTIVE_ROTATE |
  Sculpteo3DViewerCommon.INTERACTIVE_PAN |
  Sculpteo3DViewerCommon.INTERACTIVE_SCALE;

Sculpteo3DViewerCommon.INTERACTIVE_LOAD = 1 << 24;
Sculpteo3DViewerCommon.INTERACTIVE_PROGRESS = 1 << 25;
Sculpteo3DViewerCommon.INTERACTIVE_BBOX = 1 << 26;
Sculpteo3DViewerCommon.INTERACTIVE_ERRORMSG = 1 << 27;
Sculpteo3DViewerCommon.INTERACTIVE_WARNING = 1 << 28;
Sculpteo3DViewerCommon.INTERACTIVE_GROUPS = 1 << 29;
Sculpteo3DViewerCommon.INTERACTIVE_LOADING_ERROR = 1 << 30;

Sculpteo3DViewerCommon.DRAWMODE_FLAT = 1 << 0;
Sculpteo3DViewerCommon.DRAWMODE_WIREFRAME = 1 << 1;
Sculpteo3DViewerCommon.DRAWMODE_BBOX = 1 << 2;
Sculpteo3DViewerCommon.DRAWMODE_NO_CUT = 1 << 3;
Sculpteo3DViewerCommon.DRAWMODE_ON_TOP = 1 << 4;

// Set the CSG rendering mode, if supported by the viewer
Sculpteo3DViewerCommon.CSG_MODE_NONE = 0; // No CSG rendering, interescted and subtracted shapes are drawn in wireframe
Sculpteo3DViewerCommon.CSG_MODE_CONVEX = 1; // Convex CSG rendering, boolean operations involving non-convex shapes may not be drawn properly
Sculpteo3DViewerCommon.CSG_MODE_ANY = 2; // Generic CSG rendering, operations are always rendered properly

Sculpteo3DViewerCommon.prototype.isTouchDevice = function () {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};

Sculpteo3DViewerCommon.prototype.color3b_to_html = function (r, g, b) {
  var c;

  c =
    "#" +
    (r < 16 ? "0" : "") +
    parseInt(r).toString(16) +
    (g < 16 ? "0" : "") +
    parseInt(g).toString(16) +
    (b < 16 ? "0" : "") +
    parseInt(b).toString(16);

  return c;
};

Sculpteo3DViewerCommon.prototype.setShowHelp = function (showhelp) {};

Sculpteo3DViewerCommon.prototype.mapToSphere = function (x, y, v) {
  var adjustWidth = 1.0 / ((this.width - 1.0) * 0.5);
  var adjustHeight = 1.0 / ((this.height - 1.0) * 0.5);

  var px = x * adjustWidth - 1.0;
  var py = 1.0 - y * adjustHeight;

  if (this.current_moveable) {
    px *= this.zoom;
    py *= this.zoom;

    // Node to world space transform
    var transform = this.mvMatrix.x(this.current_moveable.transform);
    var center = transform.x([0, 0, 0, 1]);

    // Log("p_ss = " + px + "," + py);
    // Log("origin_ss = ");
    // Log(center);
    var X = transform.x([1, 0, 0, 0]);
    var Y = transform.x([0, 1, 0, 0]);
    var Z = transform.x([0, 0, 1, 0]);

    var scalex = X[0] * X[0] + X[1] * X[1] + X[2] * X[2];
    var scaley = Y[0] * Y[0] + Y[1] * Y[1] + Y[2] * Y[2];
    var scalez = Z[0] * Z[0] + Z[1] * Z[1] + Z[2] * Z[2];
    var scale = scalex;

    if (scaley > scale) {
      scale = scaley;
    }

    if (scalez > scale) {
      scale = scalez;
    }

    scale = Math.sqrt(scale);

    px -= center[0];
    py -= center[1];
    px /= scale;
    py /= scale;
  }

  var isqrt2 = 0.7071067811865476;

  px *= isqrt2;
  py *= isqrt2;

  var length = px * px + py * py;

  if (length > 1.0) {
    var norm = 1.0 / Math.sqrt(length);

    v[0] = px * norm;
    v[1] = 0.0;
    v[2] = py * norm;
  } else {
    v[0] = px;
    v[1] = -Math.sqrt(1.0 - length);
    v[2] = py;
  }
};

Sculpteo3DViewerCommon.prototype.mouseCoords = function (evt, _event) {
  var x, y;
  var _this = evt.data;
  var off = _this.jself.offset();

  if (_event && _event.targetTouches && _event.targetTouches[0]) {
    x = _event.targetTouches[0].pageX - off.left;
    y = _event.targetTouches[0].pageY - off.top;
  } else {
    x = evt.pageX - off.left;
    y = evt.pageY - off.top;
  }

  _this.mouse_x = x;
  _this.mouse_y = y;
};

Sculpteo3DViewerCommon.prototype.showHoleFeature = function (color) {
  var node = this.scene.nodes["model"];
  for (var i = 0; i < node.model.length; i++) {
    var vbi = node.model[i];
    var iFeat = vbi.gi;
    if (node.features[iFeat].orientation == 0 && node.features[iFeat].set & 1) {
      vbi.baseMat = color;
    }
    vbi.material = vbi.baseMat;
  }
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.showEnclosedFeature = function (color) {
  var node = this.scene.nodes["model"];
  for (var i = 0; i < node.model.length; i++) {
    var vbi = node.model[i];
    var iFeat = vbi.gi;
    if (node.features[iFeat].set & 2) {
      vbi.baseMat = { color: { r: 255, g: 0, b: 0, a: 255 } };
    }
    vbi.material = vbi.baseMat;
  }
  this.setUpdate(true);
};

// This is mostly copy-pasted from activateFeaturePicking
Sculpteo3DViewerCommon.prototype.activateGroupPicking = function (
  node_key,
  onClick,
  onHover
) {
  var node_instance = this.scene.instances[node_key];
  if (!node_instance) {
    return;
  }
  this._oldSetLocal = this.local;
  this.setLocal(true);
  node = this.scene.nodes[node_instance.name];
  this.renderNodeMap = this.renderVbosMap;
  var _this = this;
  this.canUpdate = true;
  var mouseOver = function (evt) {
    if (_this.canUpdate) {
      _this.mouseCoords(evt);
      var __x =
        ((2.0 * _this.mouse_x) / (_this.width - 1.0) - 1.0) * _this.zoomx;
      var __y =
        ((2.0 * _this.mouse_y) / (_this.height - 1.0) - 1.0) * -_this.zoomy;
      var vbos = _this.vbosAtLocation(__x, __y);
      if (vbos) {
        onHover(node_instance.name, vbos.group, evt);
      } else {
        onHover(node_instance.name, undefined, evt);
      }
      _this.setUpdate(true);
    }
  };
  var mouseClick = function (evt) {
    if (_this.canUpdate) {
      _this.mouseCoords(evt);
      var __x =
        ((2.0 * _this.mouse_x) / (_this.width - 1.0) - 1.0) * _this.zoomx;
      var __y =
        ((2.0 * _this.mouse_y) / (_this.height - 1.0) - 1.0) * -_this.zoomy;
      var vbos = _this.vbosAtLocation(__x, __y);
      if (vbos) {
        onClick(node_instance.name, vbos.group, evt);
      } else {
        onClick(node_instance.name, undefined, evt);
      }
      _this.setUpdate(true);
    }
  };
  node.groupListeners = [mouseOver, mouseClick];
  this.jself.bind("mousemove", this, mouseOver);
  this.jself.bind("mousedown", this, mouseClick);
  this.jself.bind("mouseup", this, mouseClick);
  this.featureActivateListeners = true;
  return node.markups;
};

// This is mostly copy-pasted from deactivateFeaturePicking
Sculpteo3DViewerCommon.prototype.deactivateGroupPicking = function (node_key) {
  var node_instance = this.scene.instances[node_key];
  if (!node_instance) {
    return;
  }
  var node = this.scene.nodes[node_instance.name];
  if (!node.groupListeners || !node.model) return;
  this.setLocal(this._oldSetLocal);
  if (this.featureRenderVbos) this.renderVbosMap(nodes);
  var proto = Object.getPrototypeOf(this);
  this.renderNodeMap = proto.renderNodeMap;

  if (this.featureActivateListeners) {
    var events = this.jself.data("events");
    var mousemoves = events["mousemove"];
    var i = mousemoves.indexOf(node.groupListeners[0]);
    mousemoves.splice(i, 1);
    var clicks = events["mousedown"];
    i = clicks.indexOf(node.groupListeners[1]);
    clicks.splice(i, 1);
    var mouseups = events["mouseup"];
    i = mouseups.indexOf(node.groupListeners[1]);
    mouseups.splice(i, 1);
  }
  delete node.groupListeners;
};

Sculpteo3DViewerCommon.prototype.activateFeaturePicking = function (
  node,
  featureHover,
  featureClick,
  renderVbos,
  activateListeners,
  selectedMap
) {
  this._oldSetLocal = this.local;
  this.setLocal(true);
  node = this.scene.nodes[node.id];
  var nodes = [node];
  var highlightColor = { r: 0, g: 255, b: 255, a: 255 };
  var baseColor = { r: 255, g: 255, b: 255, a: 255 };
  if (renderVbos) this.renderVbosMap(nodes);
  this.renderNodeMap = this.renderVbosMap;
  node.model.forEach(function (vbi) {
    var iFeat = vbi.gi;
    vbi.origMat = vbi.material;
    //if(node.features[iFeat].set & 2){
    //vbi.baseMat = {color:{r:255, g:0, b:0, a:255}};
    //}else if(node.features[iFeat].orientation == 0 &&
    //(node.features[iFeat].set & 1)){
    //vbi.baseMat = {color:{r:255, g:0, b:255, a:255}};
    //}else{
    vbi.baseMat = { color: baseColor };
    //}
    vbi.material = vbi.baseMat;
    vbi.select = function () {
      vbi.baseMat = { color: highlightColor };
      vbi.material = vbi.baseMat;
      vbi.feature_picked = 1;
    };
    vbi.unSelect = function () {
      vbi.baseMat = { color: baseColor };
      vbi.material = vbi.baseMat;
      vbi.feature_picked = 1;
    };
    if (selectedMap && iFeat in selectedMap) vbi.select();
  });
  var _this = this;
  var setVbosColor = function (_vbos, _mat) {
    for (var i = 0; i < _vbos.length; i++) {
      _vbos[i].material = _mat;
      _vbos[i].feature_picked = 1;
    }
  };
  var setVbosColorFromIdx = function (idx, _mat) {
    _vbos = [];
    for (var i = 0; i < idx.length; i++) {
      var id = idx[i];
      _vbos.push(node.model[id]);
    }
    setVbosColor(_vbos, _mat);
    _this.setUpdate(true);
  };
  this.canUpdate = true;
  this.setVbosColorFromIdx = setVbosColorFromIdx;
  var mouseOver = function (evt) {
    if (_this.canUpdate) {
      _this.mouseCoords(evt);
      var __x =
        ((2.0 * _this.mouse_x) / (_this.width - 1.0) - 1.0) * _this.zoomx;
      var __y =
        ((2.0 * _this.mouse_y) / (_this.height - 1.0) - 1.0) * -_this.zoomy;

      var vbos = _this.vbosAtLocation(__x, __y);
      for (var i = 0; i < node.model.length; i++) {
        var vbi = node.model[i];
        //var baseMat = {color:{r:255, g:255, b:255, a:255}};
        vbi.material = vbi.baseMat;
        vbi.feature_picked = 0;
      }
      if (vbos && vbos.gi >= 0) {
        setVbosColor([vbos], { color: highlightColor });
        if (featureHover) featureHover(node.features[vbos.gi], vbos);
      }
      _this.setUpdate(true);
    }
  };
  var mouseClick = function (evt) {
    if (_this.canUpdate) {
      _this.mouseCoords(evt);
      var __x =
        ((2.0 * _this.mouse_x) / (_this.width - 1.0) - 1.0) * _this.zoomx;
      var __y =
        ((2.0 * _this.mouse_y) / (_this.height - 1.0) - 1.0) * -_this.zoomy;
      var vbos = _this.vbosAtLocation(__x, __y);
      if (vbos) {
        if (featureClick) featureClick(node.features[vbos.gi], vbos);
      }
    }
  };
  this.featurePickingActivated = [mouseOver, mouseClick];
  if (activateListeners) {
    this.jself.bind("mousemove", this, mouseOver);
    this.jself.bind("mousedown", this, mouseClick);
  }
  this.featureRenderVbos = renderVbos;
  this.featureActivateListeners = activateListeners;
  return node.markups;
};

Sculpteo3DViewerCommon.prototype.deactivateFeaturePicking = function (node) {
  if (!this.featurePickingActivated) return;
  var node = this.scene.nodes[node.id];
  var nodes = [node];
  this.setLocal(this._oldSetLocal);
  if (this.featureRenderVbos) this.renderVbosMap(nodes);
  var proto = Object.getPrototypeOf(this);
  this.renderNodeMap = proto.renderNodeMap;
  for (var i = 0; i < node.model.length; i++) {
    var vbi = node.model[i];
    vbi.material = vbi.origMat;
    vbi.feature_picked = 0;
  }
  this.featurePickingActivated = false;
  if (this.featureActivateListeners) {
    var events = this.jself.data("events");
    var mousemoves = events["mousemove"];
    var i = mousemoves.indexOf(this.featurePickingActivated[0]);
    mousemoves.splice(i, 1);
    var clicks = events["mousedown"];
    i = clicks.indexOf(this.featurePickingActivated[1]);
    clicks.splice(i, 1);
  }
};

// Mousedown event handler.
Sculpteo3DViewerCommon.prototype.mouseDown = function (evt) {
  var _this = evt.data;
  var adjustWidth = 1.0 / ((_this.width - 1.0) * 0.5);
  var adjustHeight = 1.0 / ((_this.height - 1.0) * 0.5);

  this.mouseHasMoved = false;

  _this.postEvent("mousedown", evt.button);

  if (evt.which == MouseButton.left) {
    this.mouseDownPosition = {
      x: evt.pageX,
      y: evt.pageY,
    };
  }

  _this.jself.focus();

  if (_this.loading_bbox || _this.mouse_disabled) {
    return false;
  }

  var topmost = _this.topmostLayer(
    _this.mouse_x,
    _this.mouse_y,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEDOWN,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEDOWN
  );

  if (topmost) {
    _this.mousedown_layer = topmost;

    // Log("mousedown layer " + topmost.key);
    _this.postEvent(
      "layer",
      topmost.key,
      "mousedown",
      "" + _this.mouse_x,
      "" + _this.mouse_y,
      "" + topmost.layout.x,
      "" + topmost.layout.y
    );
  }

  // Stop autorotate if background is clicked
  topmost = _this.topmostLayer(_this.mouse_x, _this.mouse_y);

  if (topmost == _this.ui.root) {
    _this.mousedown_autorotate = _this.autorotate || _this.dirty;
    _this.autorotate = false;
  }

  if (!_this.touch_device && _this.control_hidden && _this.showControls) {
    _this.showControls();

    return false;
  }

  if (evt.type == "touchstart") {
    _this.touch_topmost = _this.topmostLayer(
      _this.mouse_x,
      _this.mouse_y,
      Sculpteo3DViewerCommon.INTERACTIVE_CLICK,
      Sculpteo3DViewerCommon.INTERACTIVE_CLICK
    );

    if (_this.touches == 0) {
      _this.mouseCoords(evt, evt.originalEvent);
    }
  } else {
    _this.mouseCoords(evt, null);
  }

  _this.mousedown_x = _this.mouselast_x = _this.mouse_x;
  _this.mousedown_y = _this.mouselast_y = _this.mouse_y;

  if (evt.type == "touchstart") {
    _this.touches += event.touches.length;
    _this.mousedown[0] =
      _this.mousedown[1] =
      _this.mousedown[2] =
      _this.mousedown[3] =
        false;
    _this.mousedown[_this.touches] = true;
  } else {
    _this.mousedown[evt.which] = true;
  }

  if (
    _this.ui &&
    _this.ui.mousedown &&
    !_this.ui.mousedown(
      _this.mouse_x * adjustWidth - 1.0,
      -(_this.mouse_y * adjustHeight - 1.0)
    )
  ) {
    return false;
  }

  if (topmost != _this.ui.root) {
    delete _this.sp;

    return false;
  }

  if (_this.scene) {
    var pos = _this.getPositionFromXY(_this.mouse_x, _this.mouse_y);
    var nodes = _this.nodesAtLocation(_this.mouse_x, _this.mouse_y);
    var old_focus_key = _this.current_focus
      ? _this.current_focus.instance.key
      : null;

    _this.blur_on_click = true;
    delete _this.current_moveable;

    for (var k = 0; k < nodes.length; k++) {
      var node = nodes[k];
      var interactive = node.instance.interactive;

      for (var p = node.instance.parent; p; p = p.parent) {
        interactive |= p.interactive;
      }

      if (
        interactive &
        (Sculpteo3DViewerCommon.INTERACTIVE_CLICK |
          Sculpteo3DViewerCommon.INTERACTIVE_MOUSEENTER |
          Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE |
          Sculpteo3DViewerCommon.INTERACTIVE_MOUSEDOWN |
          Sculpteo3DViewerCommon.INTERACTIVE_MOUSEUP |
          Sculpteo3DViewerCommon.INTERACTIVE_MOUSEMOVE)
      ) {
        _this.current_focus = nodes[k];

        if ((interactive & Sculpteo3DViewerCommon.INTERACTIVE_MOVE) != 0) {
          _this.current_moveable = _this.current_focus;
        }

        _this.blur_on_click = false;
        break;
      }
    }

    var new_focus_key = _this.current_focus
      ? _this.current_focus.instance.key
      : null;

    if (new_focus_key != old_focus_key) {
      if (old_focus_key) {
        _this.postEvent("node", old_focus_key, "blur");
      }

      if (new_focus_key) {
        _this.postEvent("node", new_focus_key, "focus");
      }
    }

    for (var k = 0; k < nodes.length; k++) {
      var node = nodes[k];
      var interactive = node.instance.interactive;

      for (var p = node.instance.parent; p; p = p.parent) {
        interactive |= p.interactive;
      }

      if (interactive & Sculpteo3DViewerCommon.INTERACTIVE_MOUSEDOWN) {
        _this.postEvent(
          "node",
          nodes[k].instance.key,
          "mousedown",
          _this.mouse_x,
          _this.mouse_y,
          pos[0],
          pos[1],
          pos[2],
          pos[3],
          pos[4],
          pos[5]
        );
        delete _this.sp;

        return false;
      }
    }

    // Log(nodes);
  }

  if (_this.current_moveable) {
    _this.last_transform = _this.current_moveable.instance.transform;
  } else {
    _this.last_rotq = {
      w: _this.rotq.w,
      x: _this.rotq.x,
      y: _this.rotq.y,
      z: _this.rotq.z,
    };
  }

  _this.sp = new Array();
  _this.mapToSphere(_this.mouse_x, _this.mouse_y, _this.sp);

  if (!_this.touch_device && _this.showControls) {
    _this.showControls();
  }

  _this.cancelRemote();

  return false;
};

Sculpteo3DViewerCommon.prototype.mouseClick = function (evt) {
  var _this = evt.data;

  /* Generate layers click events */
  var topmost = _this.topmostLayer(
    _this.mouse_x,
    _this.mouse_y,
    Sculpteo3DViewerCommon.INTERACTIVE_CLICK,
    Sculpteo3DViewerCommon.INTERACTIVE_CLICK
  );

  if (topmost) {
    //log("click layer " + topmost.key);
    _this.postEvent(
      "layer",
      topmost.key,
      "click",
      "" + _this.mouse_x,
      "" + _this.mouse_y,
      "" + topmost.layout.x,
      "" + topmost.layout.y
    );
  }

  return false;
};

Sculpteo3DViewerCommon.prototype.setCursorStyle = function (style) {
  this.jself.css({
    cursor: style,
  });
};

Sculpteo3DViewerCommon.prototype.keypress = function (evt) {
  var _this = evt.data;
  var code = evt.keyCode;
  var character = String.fromCharCode(evt.charCode);

  if (_this.ui && _this.ui.keypress && !_this.ui.keypress(code, character)) {
    return;
  }

  _this.postEvent("keypress", code, character);
};

Sculpteo3DViewerCommon.prototype.keyDown = function (evt) {
  this.keyHeld = evt.keyCode;
};

Sculpteo3DViewerCommon.prototype.keyUp = function (evt) {
  this.keyHeld = null;
};

Sculpteo3DViewerCommon.prototype.mouseUp = function (evt) {
  var _this = evt.data;
  var adjustWidth = 1.0 / ((_this.width - 1.0) * 0.5);
  var adjustHeight = 1.0 / ((_this.height - 1.0) * 0.5);
  var offset = $(".Sculpteo3DViewer").offset();
  var mouseX = evt.pageX - offset.left;
  var mouseY = evt.pageY - offset.top;

  if (!this.mouseHasMoved) {
    // Check whether we're trying to select node by clicking it directly.
    if (evt.which == MouseButton.left) {
      var clickedNodes = _this.nodesAtLocation(mouseX, mouseY, 0);

      _this.postEvent("select_node", clickedNodes);
    }
  } else if (_this.selectionRect) {
    // Or check whether we're trying to select several nodes by performing a rectangle selection.
    var clickedNodes = _this.nodesAtSelection(_this.selectionRect, 0);

    _this.postEvent("select_node", clickedNodes);
  }

  this.mouseDownPosition = null;
  _this.selectionRect = null;

  if (_this.loading_bbox || _this.mouse_disabled) {
    return false;
  }

  if (evt.type != "touchend") {
    _this.mouseCoords(evt, null);
  }

  var pos = _this.getPositionFromXY(_this.mouse_x, _this.mouse_y);
  var nodes = _this.nodesAtLocation(
    _this.mouse_x,
    _this.mouse_y,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEUP
  );

  for (var k = 0; k < nodes.length; k++) {
    var node = nodes[k];
    var interactive = node.instance.interactive;

    for (var p = node.instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }

    if (interactive & Sculpteo3DViewerCommon.INTERACTIVE_MOUSEUP) {
      _this.postEvent(
        "node",
        nodes[k].instance.key,
        "mouseup",
        _this.mouse_x,
        _this.mouse_y,
        pos[0],
        pos[1],
        pos[2],
        pos[3],
        pos[4],
        pos[5]
      );

      if (evt.type == "touchend") {
        _this.touches = 0;
        _this.mousedown[0] =
          _this.mousedown[1] =
          _this.mousedown[2] =
          _this.mousedown[3] =
            false;
      } else {
        _this.mousedown[evt.which] = false;
      }

      if (_this.sp) {
        _this.setUpdate(false);
      }

      return;
    }
  }

  var topmost = _this.topmostLayer(
    _this.mouse_x,
    _this.mouse_y,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEUP,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEUP
  );

  if (evt.type == "touchend") {
    var touch_topmost = _this.topmostLayer(
      _this.mouse_x,
      _this.mouse_y,
      Sculpteo3DViewerCommon.INTERACTIVE_CLICK,
      Sculpteo3DViewerCommon.INTERACTIVE_CLICK
    );

    if (
      _this.touch_topmost &&
      touch_topmost &&
      _this.touch_topmost == touch_topmost
    ) {
      // Simulate click
      //log("click layer " + touch_topmost.key);
      _this.postEvent(
        "layer",
        touch_topmost.key,
        "click",
        "" + _this.mouse_x,
        "" + _this.mouse_y,
        "" + touch_topmost.layout.x,
        "" + touch_topmost.layout.y
      );
    }

    _this.touch_topmost = null;
  }

  if (topmost) {
    // Log("mouseup layer " + topmost.key);
    _this.postEvent(
      "layer",
      topmost.key,
      "mouseup",
      "" + _this.mouse_x,
      "" + _this.mouse_y,
      "" + topmost.layout.x,
      "" + topmost.layout.y
    );
    topmost = null;
  }

  if (
    _this.mouse_x == _this.mousedown_x &&
    _this.mouse_y == _this.mousedown_y
  ) {
    if (_this.mousedown[1] && !(_this.mousedown[3] || _this.mousedown[2])) {
      // Click
      _this.mousedown[1] = false;

      if (_this.blur_on_click) {
        var old_focus_key = _this.current_focus
          ? _this.current_focus.instance.key
          : null;

        if (old_focus_key) {
          delete _this.current_focus;
          delete _this.current_moveable;
          _this.postEvent("node", old_focus_key, "blur");
        }
      }

      if (
        _this.ui &&
        _this.ui.click &&
        !_this.ui.click(
          _this.mouse_x * adjustWidth - 1.0,
          -(_this.mouse_y * adjustHeight - 1.0)
        )
      ) {
        return;
      }

      topmost = _this.topmostLayer(_this.mouse_x, _this.mouse_y);

      if (topmost != _this.ui.root) {
        return;
      }

      var x = _this.mouse_x;
      var y = _this.mouse_y;

      // Post click event
      var args = [
        "click",
        "" + pos[0],
        "" + pos[1],
        "" + pos[2],
        "" + pos[3],
        "" + pos[4],
        "" + pos[5],
      ];

      if (_this.cursorInstance) {
        var transform = _this.cursorInstance.transform.x(
          _this.cursorInstance.proto.transform.inverse()
        );

        args.push(transform.toString());
      }

      if (_this.current_focus) {
        _this.postEvent(
          "node",
          _this.current_focus.instance.key,
          "click",
          _this.mouse_x,
          _this.mouse_y,
          pos[0],
          pos[1],
          pos[2],
          pos[3],
          pos[4],
          pos[5]
        );
      } else {
        // If someone clicked on a node forwarding it as an argument
        // It can be used to retrieve the design which was clicked
        // Especially useful for multipart...
        if (nodes[0]) {
          args.push(nodes[0].instance.key);
        }

        _this.postEvent.apply(_this, args);
      }

      if (_this.mousedown_autorotate) {
        _this.mousedown_autorotate = false;
        _this.setUpdate(false);
      }

      return;
    }

    if (_this.mousedown[3]) {
      // Contextmenu
      topmost = _this.topmostLayer(_this.mouse_x, _this.mouse_y);

      if (topmost != _this.ui.root) {
        return;
      }

      _this.postEvent.apply(_this, ["contextmenu"]);
    }
  }

  if (evt.type == "touchend") {
    _this.touches = 0;
    _this.mousedown[0] =
      _this.mousedown[1] =
      _this.mousedown[2] =
      _this.mousedown[3] =
        false;
  } else {
    _this.mousedown[evt.which] = false;
  }

  var adjustWidth = 1.0 / ((_this.width - 1.0) * 0.5);
  var adjustHeight = 1.0 / ((_this.height - 1.0) * 0.5);

  if (
    _this.ui &&
    _this.ui.mouseup &&
    !_this.ui.mouseup(
      _this.mouse_x * adjustWidth - 1.0,
      -(_this.mouse_y * adjustHeight - 1.0)
    )
  ) {
    return false;
  }

  if (_this.sp) {
    _this.setUpdate(false);
  }

  return false;
};

Sculpteo3DViewerCommon.prototype.invalidateRemote = function () {
  this.$imageDiv.css("opacity", 0.3);
};

Sculpteo3DViewerCommon.prototype.cancelRemote = function (abort) {
  if (this.scene_timeout) {
    clearTimeout(this.scene_timeout);
  }

  if (this.timeout) {
    clearTimeout(this.timeout);
  }

  if (this.timeout2) {
    clearTimeout(this.timeout2);
  }
  if (abort && window.viewer && window.viewer.xhr) {
    window.viewer.xhr.abort();
  }
  this.imageurl = null;
  this.imageurl2 = null;
};

Sculpteo3DViewerCommon.prototype._insideBox = function (xr, yr, w, h, inset) {
  if (
    !(
      (w > 0 ? xr >= 0 && xr <= w : xr <= 0 && xr >= w) &&
      (h > 0 ? yr >= 0 && yr <= h : yr <= 0 && yr >= h)
    )
  ) {
    return 9; // Outside
  }

  if (!inset) {
    return 4; // Center
  }

  var code = 0;

  if (w > 0) {
    if (xr < inset) {
      code--;
    }

    if (xr > w - inset) {
      code++;
    }
  } else {
    if (xr > -inset) {
      code--;
    }

    if (xr < -(w - inset)) {
      code++;
    }
  }

  if (h > 0) {
    if (yr < inset) {
      code -= 3;
    }

    if (yr > h - inset) {
      code += 3;
    }
  } else {
    if (yr > -inset) {
      code -= 3;
    }

    if (yr < -(h - inset)) {
      code += 3;
    }
  }

  return code + 4;
};

Sculpteo3DViewerCommon.prototype.insideBox = function (x, y, x0, y0, x1, y1) {
  var w = x1 - x0;
  var h = y1 - y0;
  var xo = x - x0;
  var yo = y - y0;

  return this._insideBox(xo, yo, w, h, 0.0) != 9;
};

Sculpteo3DViewerCommon.prototype.overLayers = function (x, y) {
  var res = {};

  if (!this.ui) {
    return res;
  }

  for (var k in this.ui.layout) {
    if (!this.ui.layout.hasOwnProperty(k)) continue;
    var layer = this.ui.layout[k];
    var x0 = layer.layout.x;
    var y0 = layer.layout.y;
    var x1 = x0 + layer.frame.w;
    var y1 = y0 + layer.frame.h;

    if (this.insideBox(x, y, x0, y0, x1, y1)) {
      res[layer.key] = layer;
    }
  }

  return res;
};

Sculpteo3DViewerCommon.prototype.topmostLayer = function (x, y, mask, value) {
  if (!this.ui) {
    return null;
  }

  var topmost = null;

  for (var k in this.ui.layout) {
    var layer = this.ui.layout[k];
    var x0 = layer.layout.x;
    var y0 = layer.layout.y;
    var x1 = x0 + layer.frame.w;
    var y1 = y0 + layer.frame.h;

    if (typeof mask != "undefined" && (layer.interactive & mask) != value) {
      continue;
    }

    if (this.insideBox(x, y, x0, y0, x1, y1)) {
      topmost = layer;
    }
  }

  return topmost;
};

Sculpteo3DViewerCommon.prototype._relayout = function (
  layout,
  offx,
  offy,
  layer
) {
  var x = offx + layer.frame.x + layer.border;
  var y = offy + layer.frame.y + layer.border;
  var k;

  layer.layout = {
    x: x,
    y: y,
  };

  layout.push(layer);

  for (k = 0; k < layer.children.length; k++) {
    var child = layer.children[k];

    this._relayout(layout, x, y, child);
  }
};

Sculpteo3DViewerCommon.prototype.relayout = function () {
  // Compute layers positions recursively
  var layout = [];

  this._relayout(layout, 0, 0, this.ui.root);
  this.ui.layout = layout;
};

Sculpteo3DViewerCommon.prototype._layoutChanged = function () {
  if (this.relayoutTimeout) {
    clearTimeout(this.relayoutTimeout);
  }

  var that = this;

  this.relayoutTimeout = setTimeout(function () {
    that.relayout();
  });
};

Sculpteo3DViewerCommon.prototype._setRootLayer = function (layer) {
  layer.$el.css({
    overflow: "hidden",
  });
  this.jself.append(layer.$el);
};

Sculpteo3DViewerCommon.prototype.rootLayer = function () {
  return this.ui.root.key;
};

Sculpteo3DViewerCommon.prototype.createLayer = function (l) {
  var key = "";
  var layer = new Sculpteo3DViewerCommonLayer();

  for (var i = 0; i < 32; i++) {
    key += ((Math.random() * 16) | 0).toString(16);
  }

  this.ui.layers[key] = layer;
  layer.key = key;

  return key;
};

Sculpteo3DViewerCommon.prototype.deleteLayer = function (key) {
  delete this.ui.layers[key];
};

Sculpteo3DViewerCommon.prototype._attachLayer = function (
  parent_key,
  child_key
) {
  var parent = this.ui.layers[parent_key];

  if (!parent) {
    return;
  }

  var child = this.ui.layers[child_key];

  if (!child) {
    return;
  }

  // A layer may be attached to a single parent only
  if (child.parent) {
    return;
  }

  child.parent = parent;
  parent.children.push(child);

  // Call layer implementation specific method
  parent.attach(child);

  this._layoutChanged();
};

Sculpteo3DViewerCommon.prototype._detachLayer = function (key) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  if (!layer.parent) {
    return;
  }

  // Call layer implementation specific method
  layer.detach();

  // Remove from parent list
  for (var i = layer.parent.children.length; i >= 0; i--) {
    if (layer.parent.children[i] === layer) {
      layer.parent.children.splice(i, 1);
      break;
    }
  }

  delete layer.parent;
  this._layoutChanged();
};

Sculpteo3DViewerCommon.prototype.setLayerFrame = function (key, x, y, w, h) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setFrame(x, y, w, h);
  this._layoutChanged();
};

Sculpteo3DViewerCommon.prototype.addLayerClass = function (key, className) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.addClass(className);
};

Sculpteo3DViewerCommon.prototype.setLayerOpacity = function (key, opacity) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setOpacity(opacity);
  this._layoutChanged();
};

Sculpteo3DViewerCommon.prototype.setLayerInteractive = function (key, enable) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.interactive = enable;
};

Sculpteo3DViewerCommon.prototype.setLayerBorderColor = function (
  key,
  r,
  g,
  b,
  a
) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setBorderColor(r, g, b, a);
};

Sculpteo3DViewerCommon.prototype.setLayerBorderWidth = function (key, width) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setBorderWidth(width);

  this._layoutChanged();
};

Sculpteo3DViewerCommon.prototype.setLayerBorderRadius = function (key, radius) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setBorderRadius(radius);
};

Sculpteo3DViewerCommon.prototype.setLayerBackgroundColor = function (
  key,
  r,
  g,
  b,
  a
) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setBackgroundColor(r, g, b, a);
};

Sculpteo3DViewerCommon.prototype.setLayerBackgroundImage = function (
  key,
  image_key,
  offx,
  offy
) {
  var layer = this.ui.layers[key];
  var url;

  if (!layer) {
    return;
  }

  if (image_key) {
    url = this.ui.images[image_key];
  }

  layer.setBackgroundImage(url, offx, offy);
};

Sculpteo3DViewerCommon.prototype.setLayerBackgroundText = function (
  key,
  font,
  str,
  r,
  g,
  b,
  a,
  offx,
  offy
) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setBackgroundText(font, str, r, g, b, a, offx, offy);
};

Sculpteo3DViewerCommon.prototype.setZIndex = function (key, zIndex) {
  var layer = this.ui.layers[key];

  if (!layer) {
    return;
  }

  layer.setZIndex(zIndex);
};

Sculpteo3DViewerCommon.prototype.createImage = function (url) {
  var key = "";

  for (var i = 0; i < 32; i++) {
    key += ((Math.random() * 16) | 0).toString(16);
  }

  this.ui.images[key] = url;

  return key;
};

Sculpteo3DViewerCommon.prototype.deleteImage = function (key) {
  delete this.ui.images[key];
};

// TODO: support touchpad!
Sculpteo3DViewerCommon.prototype.mouseMove = function (evt) {
  var _this = evt.data;
  var adjustWidth = 1.0 / ((_this.width - 1.0) * 0.5);
  var adjustHeight = 1.0 / ((_this.height - 1.0) * 0.5);

  // If the left button of the mouse is currently pressed
  if (this.mouseDownPosition) {
    this.mouseHasMoved = true;

    // update the selection rectangle if available
    if (_this.selectionRect || this.keyHeld === KeyCode.shift) {
      var offset = $("#viewer3d").offset();
      var mouseX = evt.pageX - offset.left;
      var mouseY = evt.pageY - offset.top;
      var downX = this.mouseDownPosition.x - offset.left;
      var downY = this.mouseDownPosition.y - offset.top;

      _this.selectionRect = {
        x: Math.min(downX, mouseX),
        y: Math.min(downY, mouseY),
        w: Math.abs(downX - mouseX),
        h: Math.abs(downY - mouseY),
      };

      _this.setUpdate(true);
    }
  }

  if (_this.loading_bbox || _this.mouse_disabled) {
    return false;
  }

  if (evt.type == "touchmove") {
    _this.mouseCoords(evt, evt.originalEvent);
  } else {
    _this.mouseCoords(evt, null);
  }

  if (!_this.touch_device && _this.showControls) {
    _this.showControls();
  }

  if (
    _this.ui &&
    _this.ui.mousemove &&
    !_this.ui.mousemove(
      _this.mouse_x * adjustWidth - 1.0,
      -(_this.mouse_y * adjustHeight - 1.0)
    )
  ) {
    return;
  }

  /* Generate layers mouseenter/mouseleave events */
  var layers = _this.overLayers(_this.mouse_x, _this.mouse_y);
  var k;

  if (!_this.overlayers) {
    _this.overlayers = {};
  }

  for (var k in _this.overlayers) {
    if (
      !layers[k] &&
      _this.overlayers[k].interactive &
        Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE
    ) {
      // Log("mouseleave layer " + _this.overlayers[k].key);
      _this.postEvent("layer", _this.overlayers[k].key, "mouseleave");
    }
  }

  for (var k in layers) {
    if (
      !_this.overlayers[k] &&
      layers[k].interactive & Sculpteo3DViewerCommon.INTERACTIVE_MOUSEENTER
    ) {
      // Log("mouseenter layer " + layers[k].key);
      _this.postEvent("layer", layers[k].key, "mouseenter");
    }
  }

  _this.overlayers = layers;

  var topmost = _this.topmostLayer(
    _this.mouse_x,
    _this.mouse_y,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEMOVE,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEMOVE
  );

  if (topmost) {
    _this.postEvent(
      "layer",
      topmost.key,
      "mousemove",
      "" + _this.mouse_x,
      "" + _this.mouse_y,
      "" + topmost.layout.x,
      "" + topmost.layout.y
    );
  }

  /* Generate node mouseenter/mouseleave events */
  var nodes = _this.overNodes(
    _this.mouse_x,
    _this.mouse_y,
    Sculpteo3DViewerCommon.INTERACTIVE_MOUSEENTER |
      Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE
  );

  if (!_this.overnodes) {
    _this.overnodes = {};
  }

  for (var k in _this.overnodes) {
    var instance = _this.overnodes[k];
    var interactive = instance.interactive;

    for (var p = instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }

    if (
      !nodes[k] &&
      interactive & Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE
    ) {
      // Log("mouseleave node " + _this.overnodes[k].key);
      _this.postEvent("node", _this.overnodes[k].key, "mouseleave");
    }
  }

  for (var k in nodes) {
    var instance = nodes[k];
    var interactive = instance.interactive;

    for (var p = instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }

    if (
      !_this.overnodes[k] &&
      interactive & Sculpteo3DViewerCommon.INTERACTIVE_MOUSEENTER
    ) {
      // Log("mouseenter node " + nodes[k].key);
      _this.postEvent("node", nodes[k].key, "mouseenter");
    }
  }

  _this.overnodes = nodes;

  if (!_this.sp) {
    return false;
  }

  // this test enables us to break and leave the function earlier when we have a selection
  // rectangle; that's important, otherwise we'll rotate / move the viewer, and that's not a wished
  // behavior
  if (_this.selectionRect) {
    return false;
  }

  // rotation and movement handling right below
  if (_this.mousedown[1] && _this.MSTouchCount < 2) {
    /* Rotation */
    if (
      _this.mouse_x == _this.mousedown_x &&
      _this.mouse_y == _this.mousedown_y
    ) {
      _this.cancelRemote();
    } else {
      _this.invalidateRemote();
    }

    _this.ep = new Array();
    _this.mapToSphere(_this.mouse_x, _this.mouse_y, _this.ep);
    var sp, ep;

    sp = _this.sp;
    ep = _this.ep;

    axis_x = sp[1] * ep[2] - ep[1] * sp[2];
    axis_y = sp[2] * ep[0] - ep[2] * sp[0];
    axis_z = sp[0] * ep[1] - ep[0] * sp[1];
    axis_n = axis_x * axis_x + axis_y * axis_y + axis_z * axis_z;

    var rotq;

    if (axis_n > 1.0e-5) {
      var cos_theta_2;

      cos_theta_2 = sp[0] * ep[0] + sp[1] * ep[1] + sp[2] * ep[2];
      rotq = {
        w: cos_theta_2,
        x: axis_x,
        y: axis_y,
        z: axis_z,
      };
    } else {
      rotq = {
        w: 1.0,
        x: 0.0,
        y: 0.0,
        z: 0.0,
      };
    }

    var node = _this.current_moveable;
    var interactive = 0;

    if (node) {
      interactive = node.instance.interactive;

      for (var p = node.instance.parent; p; p = p.parent) {
        interactive |= p.interactive;
      }
    }

    if ((interactive & Sculpteo3DViewerCommon.INTERACTIVE_ROTATE) != 0) {
      var t = _this.current_moveable.transform.x([0, 0, 0, 1]);
      var node_origin = Sculpteo3DViewerCommonTransform3D.translation(
        -t[0],
        -t[1],
        -t[2]
      );

      var dRot = _this.quatMat3(rotq.w, rotq.x, rotq.y, rotq.z);

      var thisRot = _this.getModelViewMatrix();
      var R = thisRot.inverse();

      dRot = R.x(dRot).x(R.inverse());
      dRot = node_origin.inverse().x(dRot).x(node_origin);

      _this.current_moveable.instance.transform = dRot.x(_this.last_transform);

      _this.postEvent(
        "node",
        _this.current_moveable.instance.key,
        "transform",
        _this.current_moveable.instance.transform.toString()
      );
    } else {
      var _w =
        rotq.w * _this.last_rotq.w -
        rotq.x * _this.last_rotq.x -
        rotq.y * _this.last_rotq.y -
        rotq.z * _this.last_rotq.z;
      var _x =
        rotq.w * _this.last_rotq.x +
        rotq.x * _this.last_rotq.w +
        rotq.y * _this.last_rotq.z -
        rotq.z * _this.last_rotq.y;
      var _y =
        rotq.w * _this.last_rotq.y +
        rotq.y * _this.last_rotq.w +
        rotq.z * _this.last_rotq.x -
        rotq.x * _this.last_rotq.z;
      var _z =
        rotq.w * _this.last_rotq.z +
        rotq.z * _this.last_rotq.w +
        rotq.x * _this.last_rotq.y -
        rotq.y * _this.last_rotq.x;

      _this.rotq.w = _w;
      _this.rotq.x = _x;
      _this.rotq.y = _y;
      _this.rotq.z = _z;
      _this.postEvent("camera", _w, _x, _y, _z);
    }

    _this.setUpdate(true);
  }

  var panMe = true;
  if (typeof amt_options !== "undefined") {
    panMe = amt_options.rightclickpan;
  }

  if ((_this.mousedown[3] && panMe) || _this.mousedown[2]) {
    /* Panning */
    var dx = _this.mouse_x - _this.mouselast_x;
    var dy = _this.mouse_y - _this.mouselast_y;
    _this.mouselast_x = _this.mouse_x;
    _this.mouselast_y = _this.mouse_y;

    _this.handlePan.apply(_this, [dx, dy]);
  }

  return false;
};

Sculpteo3DViewerCommon.prototype.handlePan = function (dx, dy) {
  var adjustWidth = 1.0 / ((this.width - 1.0) * 0.5);
  var adjustHeight = 1.0 / ((this.height - 1.0) * 0.5);
  dx = dx * adjustWidth;
  dy = dy * adjustHeight;

  var ar = this.width / this.height;

  if (ar > 1.0) {
    dx *= ar;
  } else {
    dy /= ar;
  }

  var node = this.current_moveable;
  var interactive = 0;

  if (node) {
    interactive = node.instance.interactive;

    for (var p = node.instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }
  }

  if ((interactive & Sculpteo3DViewerCommon.INTERACTIVE_PAN) != 0) {
    var transform = this.mvMatrix.x(this.last_transform);
    var zoom = this.zoom;
    var d_ns = transform.inverse().x([dx * zoom, -dy * zoom, 0, 0]);

    // Log("d_ss = " + dx + "," + dy);
    // Log("d_ns = ");
    // Log(d_ns);

    var M = Sculpteo3DViewerCommonTransform3D.translation(
      d_ns[0],
      d_ns[1],
      d_ns[2]
    );

    this.last_transform = this.last_transform.x(M);
    this.current_moveable.instance.transform = this.last_transform;
  } else {
    this.pan_x += dx;
    this.pan_y -= dy;
    this.postEvent("pan", this.pan_x, this.pan_y, null);
  }

  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.mouseWheel = function (evt, delta) {
  var _this = evt.data;

  if (_this.loading_bbox || _this.mouse_disabled) {
    return false;
  }

  if (delta <= 0) {
    _this.handleZoom.apply(_this, [1.1]);
  } else {
    _this.handleZoom.apply(_this, [1 / 1.1]);
  }

  return false;
};

Sculpteo3DViewerCommon.prototype.handleZoom = function (level) {
  this.zoom *= level;
  this.setZoom(this.zoom);
  this.drawRuler();
  this.drawGrid();
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.mouseOut = function (evt) {
  var _this = evt.data;

  if (_this.mousedown[1] || _this.mousedown[3] || _this.mousedown[2]) {
    _this.mousedown[1] = false;
    _this.mousedown[2] = false;
    _this.mousedown[3] = false;
    _this.setUpdate(false);
  }

  /* Generate layers mouseleave events */
  if (!_this.overlayers) {
    _this.overlayers = {};
  }

  for (var k in _this.overlayers) {
    if (
      (_this.overlayers[k].interactive &
        Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE) !=
      0
    ) {
      log("mouseleave layer " + _this.overlayers[k].key);
      _this.postEvent("layer", _this.overlayers[k].key, "mouseleave");
    }
  }

  _this.overlayers = {};

  if (_this.mousedown_layer) {
    // Log("mouseup layer " + _this.mousedown_layer.key);
    _this.postEvent(
      "layer",
      _this.mousedown_layer.key,
      "mouseup",
      "" + _this.mouse_x,
      "" + _this.mouse_y,
      "" + _this.mousedown_layer.layout.x,
      "" + _this.mousedown_layer.layout.y
    );
    delete _this.mousedown_layer;
  }

  /* Generate nodes mouseleave events */
  if (!_this.overnodes) {
    _this.overnodes = {};
  }

  for (var k in _this.overnodes) {
    var instance = _this.overnodes[k];
    var interactive = instance.interactive;

    for (var p = instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }

    if ((interactive & Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE) != 0) {
      log("mouseleave node " + _this.overnodes[k].key);
      _this.postEvent("node", _this.overnodes[k].key, "mouseleave");
    }
  }

  _this.overnodes = {};

  return false;
};

Sculpteo3DViewerCommon.prototype.gestureStart = function (evt) {
  var _this = evt.data;

  _this.cancelRemote();
};

Sculpteo3DViewerCommon.prototype.gestureEnd = function (evt) {
  var _this = evt.data;

  _this.MSTouchCount = 0;
  _this.cancelRemote();
  _this.setUpdate(false);

  return false;
};

Sculpteo3DViewerCommon.prototype.gestureChange = function (evt) {
  var _this = evt.data;

  _this.cancelRemote();
  _this.zoom /= evt.originalEvent.scale;

  if (_this.zoom > 6) {
    _this.zoom = 6;
  } else if (_this.zoom < 0.2) {
    _this.zoom = 0.2;
  }

  if (_this.MSTouchCount > 1) {
    _this.pan_x += evt.originalEvent.translationX / (_this.width / 2);
    _this.pan_y += -evt.originalEvent.translationY / (_this.height / 2);
  }

  _this.setZoom(_this.zoom);
  _this.setUpdate(true);

  return false;
};

Sculpteo3DViewerCommon.prototype.getCenter = function () {
  var pos = this.getPositionFromXY(this.width / 2, this.height / 2);
  var ret = "";

  for (var k in pos) {
    ret += pos[k];

    if (k != pos.length - 1) {
      ret += ",";
    }
  }

  return ret;
};

Sculpteo3DViewerCommon.prototype.quatMat3 = function (qw, qx, qy, qz) {
  var n = qx * qx + qy * qy + qz * qz + qw * qw;
  var s;

  if (n > 0.0) {
    s = 2.0 / n;
  } else {
    s = 0.0;
  }

  var xs = qx * s;
  var ys = qy * s;
  var zs = qz * s;
  var wx = qw * xs;
  var wy = qw * ys;
  var wz = qw * zs;
  var xx = qx * xs;
  var xy = qx * ys;
  var xz = qx * zs;
  var yy = qy * ys;
  var yz = qy * zs;
  var zz = qz * zs;

  return new Sculpteo3DViewerCommonTransform3D([
    1.0 - (yy + zz),
    xy - wz,
    xz + wy,
    0,
    xy + wz,
    1.0 - (xx + zz),
    yz - wx,
    0,
    xz - wy,
    yz + wx,
    1.0 - (xx + yy),
    0,
    0,
    0,
    0,
    1,
  ]);
};

Sculpteo3DViewerCommon.prototype.quatMul = function (arot, brot) {
  return {
    w: arot.w * brot.w - arot.x * brot.x - arot.y * brot.y - arot.z * brot.z,
    x: arot.w * brot.x + arot.x * brot.w + arot.y * brot.z - arot.z * brot.y,
    y: arot.w * brot.y + arot.y * brot.w + arot.z * brot.x - arot.x * brot.z,
    z: arot.w * brot.z + arot.z * brot.w + arot.x * brot.y - arot.y * brot.x,
  };
};

Sculpteo3DViewerCommon.prototype.quatNormalize = function (arot) {
  var norm = Math.sqrt(
    arot.w * arot.w + arot.x * arot.x + arot.y * arot.y + arot.z * arot.z
  );

  if (norm) {
    return {
      w: arot.w / norm,
      x: arot.x / norm,
      y: arot.y / norm,
      z: arot.z / norm,
    };
  } else {
    return arot;
  }
};

Sculpteo3DViewerCommon.prototype.getPositionFromXY = function (x, y) {
  var scale = this.scale;
  var center_x = this.center_x;
  var center_y = this.center_y;
  var center_z = this.center_z;
  var adjustWidth = 1.0 / ((this.width - 1.0) * 0.5);
  var adjustHeight = 1.0 / ((this.height - 1.0) * 0.5);
  var p = [
    (x * adjustWidth - 1.0) * this.zoomx - this.pan_x * this.zoom,
    -2.0,
    (1.0 - y * adjustHeight) * this.zoomy - this.pan_y * this.zoom,
    1.0,
  ];

  // Transform to viewpoint
  T = this.quatMat3(
    this.rotq.w,
    this.rotq.x,
    this.rotq.y,
    this.rotq.z
  ).transpose();
  var cd = T.x([0, 1, 0, 0]);

  // Scale and translate back to object space
  T = this.scene_transform.inverse().x(T);
  var cp = T.x(p);

  return [cp[0], cp[1], cp[2], cd[0], cd[1], cd[2]];
};

Sculpteo3DViewerCommon.prototype.setTransform = function (t, noUpdate) {
  var T = t.split(/,/);

  this.rotq = {
    w: T[0],
    x: T[1],
    y: T[2],
    z: T[3],
  };

  if (!noUpdate) {
    this.setUpdate(true);
  }
};

Sculpteo3DViewerCommon.prototype.getSceneTransform = function () {
  return this.scene_transform.toString();
};

Sculpteo3DViewerCommon.prototype.setSceneTransform = function (transform) {
  this.scene_transform = new Sculpteo3DViewerCommonTransform3D(transform);
};

Sculpteo3DViewerCommon.prototype.getSceneBBox = function () {
  var _this = this;

  var caluclate_bbox = function (bbox, node, transform) {
    if (node.transform) {
      transform = transform.x(node.transform);
    }

    if (node.operation) {
      caluclate_bbox(bbox, node.A, transform);
      caluclate_bbox(bbox, node.B, transform);
    } else {
      var n = _this.scene.nodes[node.name];

      if (!n.bbox) {
        return;
      }

      for (var i = 0; i < 2; ++i) {
        for (var j = 0; j < 2; ++j) {
          for (var k = 0; k < 2; ++k) {
            var corner = [n.bbox[i].x, n.bbox[j].y, n.bbox[k].z, 1.0];
            corner = transform.x(corner);
            if (bbox[0].x > corner[0]) {
              bbox[0].x = corner[0];
            }

            if (bbox[0].y > corner[1]) {
              bbox[0].y = corner[1];
            }

            if (bbox[0].z > corner[2]) {
              bbox[0].z = corner[2];
            }

            if (bbox[1].x < corner[0]) {
              bbox[1].x = corner[0];
            }

            if (bbox[1].y < corner[1]) {
              bbox[1].y = corner[1];
            }

            if (bbox[1].z < corner[2]) {
              bbox[1].z = corner[2];
            }
          }
        }
      }
    }
  };

  var bbox = [
    { x: 1e10, y: 1e10, z: 1e10 },
    { x: -1e10, y: -1e10, z: -1e10 },
  ];

  caluclate_bbox(bbox, this.scene.root, this.scene.root.transform);

  return (
    "" +
    bbox[0].x +
    "," +
    bbox[0].y +
    "," +
    bbox[0].z +
    "," +
    bbox[1].x +
    "," +
    bbox[1].y +
    "," +
    bbox[1].z
  );
};

Sculpteo3DViewerCommon.prototype.getTransform = function () {
  return (
    this.rotq.w + "," + this.rotq.x + "," + this.rotq.y + "," + this.rotq.z
  );
};

Sculpteo3DViewerCommon.prototype.getZoom = function () {
  return this.zoom;
};

Sculpteo3DViewerCommon.prototype.setZoom = function (zoom, marker) {
  this.zoom = this.zoom_init = zoom;

  var ar = this.width / this.height;
  var zoomx, zoomy;

  if (ar > 1.0) {
    this.zoomx = this.zoom * ar;
    this.zoomy = this.zoom;
  } else {
    this.zoomx = this.zoom;
    this.zoomy = this.zoom / ar;
  }

  this.updateProjectionMatrix();

  this.postEvent("zoom", this.zoom, marker);

  this.drawRuler();
  this.drawGrid();
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setPan = function (panx, pany, marker) {
  this.pan_x = panx;
  this.pan_y = pany;
  this.updateProjectionMatrix();

  this.postEvent("pan", panx, pany, marker);

  this.drawRuler();
  this.drawGrid();
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.resetView = function () {
  this.setTransform("0.9928826,0.07926025,-0.014972103,0.08762345", false);
  this.pan_x = this.pan_y = 0;
  this.setZoom(this.zoom_init);
};

Sculpteo3DViewerCommon.prototype.sRGBtoLinear = function (C) {
  var lin = 0.0;

  if (C <= 0.03928) {
    lin = C / 12.92;
  } else {
    lin = pow((C + 0.055) / 1.055, 2.4);
  }

  return lin;
};

Sculpteo3DViewerCommon.prototype.encodeMaterial = function (material) {
  var color_to_str = function (c) {
    return (
      (c.r < 16 ? "0" : "") +
      parseInt(c.r).toString(16) +
      (c.g < 16 ? "0" : "") +
      parseInt(c.g).toString(16) +
      (c.b < 16 ? "0" : "") +
      parseInt(c.b).toString(16)
    );
  };

  if (material.ambient) {
    var mat = "full_a";

    mat += color_to_str(material.ambient.color);
    mat += "_d";
    mat += color_to_str(material.diffuse.color);
    mat += "_s";
    mat += color_to_str(material.specular.color);

    if (material.emissive) {
      mat += "_e";
      mat += color_to_str(material.emissive.color);
    } else {
      mat += "_t000000";
    }

    if (material.transmit) {
      mat += "_t";
      mat += color_to_str(material.transmit.color);
    } else {
      mat += "_t000000";
    }

    if (material.shininess) {
      mat += "_x" + material.shininess;
    } else {
      mat += "_x0.0";
    }

    if (material.ior) {
      mat += "_i" + material.ior;
    } else {
      mat += "_i1.0";
    }

    if (material.mfp) {
      mat += "_l" + material.mfp;
    } else {
      mat += "_l1.0";
    }

    if (material.perlin) {
      mat += "_p";
      mat +=
        material.perlin.amplitude +
        "_" +
        material.perlin.scale_x +
        "_" +
        material.perlin.scale_y +
        "_" +
        material.perlin.scale_z;
    } else {
      mat += "_p0.0_0.0_0.0_0.0";
    }

    if (material.solidity) {
      mat += "_sl" + material.solidity.min;
      mat += "_sh" + material.solidity.max;
    } else {
      mat += "_sl-1.0_sh-1.0";
    }

    if (typeof material.envmap != "undefined") {
      mat += "_em" + (material.envmap ? "1" : "0");
    } else {
      mat += "_em-1";
    }

    if (typeof material.smooth != "undefined") {
      mat += "_sn" + (material.smooth ? "1" : "0");
    } else {
      mat += "_sn-1";
    }

    if (typeof material.gaussian_amplitude != "undefined") {
      mat += "_ga" + material.gaussian_amplitude;
    }

    return mat;
  }
};

Sculpteo3DViewerCommon.prototype.parseMaterial = function (material) {
  if (this.materialMap[material]) return this.materialMap[material];
  var match;
  var parse_color = function (str) {
    return {
      r: parseInt(str.substring(0, 2), 16),
      g: parseInt(str.substring(2, 4), 16),
      b: parseInt(str.substring(4, 6), 16),
    };
  };

  var fill_mat_re = new RegExp(
    "^full\
(?:_(a)([0-9abcdef]{6}))?\
(?:_(d)([0-9abcdef]{6}))?\
(?:_(s)([0-9abcdef]{6}))?\
(?:_(e)([0-9abcdef]{6}))?\
(?:_(t)([0-9abcdef]{6}))?\
(?:_(x)([+-]?\\d+(?:\\.\\d+)?))?\
(?:_(i)([+-]?\\d+(?:\\.\\d+)?))?\
(?:_(l)([+-]?\\d+(?:\\.\\d+)?))?\
(?:_(p)([+-]?\\d+(?:\\.\\d+)?)_([+-]?\\d+(?:\\.\\d+)?)_([+-]?\\d+(?:\\.\\d+)?)_([+-]?\\d+(?:\\.\\d+)?))?\
(?:_(sl)([+-]?\\d+(?:\\._d+)?))?\
(?:_(sh)([+-]?\\d+(?:\\.\\d+)?))?\
(?:_(em)([+-]?\\d+))?\
(?:_(sn)([+-]?\\d+))?\
(?:_(ga)([+-]?\\d+(?:\\.\\d+)?))?"
  );

  if (material == "white_plastic") {
    return {
      color: {
        r: 255,
        g: 255,
        b: 255,
      },
    };
  } else if (material.match("^plastic_x") == "plastic_x") {
    var color_str = material.substring(9, 15);
    var mat = {};

    mat.color = parse_color(color_str);
    this.materialMap[material] = mat;

    return mat;
  } else if (
    (match = material.match(
      "^full_pbr_d([0-9,A-Z,a-z]{6})_s([0-9,A-F,a-f]{6})_([0-9, .]+)_([0-9, .]+)_([0-9, .]+)"
    ))
  ) {
    // Gloss should be fresnel0 * (1.0 - roughness)
    var diffuse_str = match[1];
    var specular_str = match[2];
    var roughness_str = match[3];
    var fresnel0_str = match[4];
    var gloss_str = match[5];

    var mat = {};

    if (diffuse_str != "color0") {
      var dr = parseInt(diffuse_str.substring(0, 2), 16);
      var dg = parseInt(diffuse_str.substring(2, 4), 16);
      var db = parseInt(diffuse_str.substring(4, 6), 16);

      mat.diffuse = {};
      mat.diffuse.color = parse_color(diffuse_str);
    }

    mat.specular = {};
    mat.specular.color = parse_color(specular_str);
    mat.roughness = parseFloat(roughness_str);
    mat.fresnel0 = parseFloat(fresnel0_str);
    mat.gloss = parseFloat(gloss_str);
    this.materialMap[material] = mat;

    return mat;
  } else if ((match = fill_mat_re.exec(material))) {
    var mat = {};

    for (var i = 0; i < match.length; ++i) {
      switch (match[i]) {
        case "a":
          mat.ambient = {};
          mat.ambient.color = parse_color(match[++i]);
          break;
        case "d":
          mat.diffuse = {};
          mat.diffuse.color = parse_color(match[++i]);
          break;
        case "s":
          mat.specular = {};
          mat.specular.color = parse_color(match[++i]);
          break;
        case "e":
          mat.emissive = {};
          mat.emissive.color = parse_color(match[++i]);
          break;
        case "t":
          mat.transmit = {};
          mat.transmit.color = parse_color(match[++i]);
          break;
        case "x":
          mat.shininess = parseFloat(match[++i]);
          break;
        case "i":
          mat.ior = parseFloat(match[++i]);
          break;
        case "l":
          mat.mfp = parseFloat(match[++i]);
          break;
        case "p":
          mat.perlin = {};
          mat.perlin.amplitude = parseFloat(match[++i]);
          mat.perlin.scale_x = parseFloat(match[++i]);
          mat.perlin.scale_y = parseFloat(match[++i]);
          mat.perlin.scale_z = parseFloat(match[++i]);
          break;
        case "sl":
          mat.solidity = {};
          mat.solidity.min = parseFloat(match[++i]);

          if (match[i + 1] == "sh") {
            i++;
            mat.solidity.max = parseFloat(match[++i]);
          } else {
            mat.solidity.max = -1.0;
          }

          break;
        case "em":
          mat.envmap = parseInt(match[++i]);
          break;
        case "sn":
          mat.smooth = parseInt(match[++i]);
          break;
        case "ga":
          mat.gaussian_amplitude = parseFloat(match[++i]);
          break;
      }
    }

    this.materialMap[material] = mat;
    return mat;
  }

  return null;
};

Sculpteo3DViewerCommon.prototype.setMaterial = function (material) {
  this.material = material;
  this.global_material = this.parseMaterial(material);
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.load_binary_resource = function (
  url,
  content,
  success,
  error,
  abort,
  headers
) {
  if (window.XMLHttpRequest) {
    var req = new XMLHttpRequest();
  } else if (window.ActiveXObject) {
    var req = new ActiveXObject("Microsoft.XMLHTTP");
  }

  var that = this;

  var use_arraybuffer = typeof req.responseType === "string";

  if (!this._load_binary_req) {
    this._load_binary_req = {};
  }

  var cb = success;

  // DEBUG: slow down the success call to simulate slow download
  /*
	Cb = function(ba, req) {
		setTimeout(function() {
				success(ba, req);
			}, 15000);
	};
	*/

  req.onreadystatechange = function () {
    // Ignore event if we started a new request
    if (!that._load_binary_req[url] || req != that._load_binary_req[url].req) {
      return;
    }

    if (req.readyState >= 2 && that._load_binary_req[url].state < 2) {
      if (headers) {
        headers(req);
      }
    }

    if (req.readyState == 4) {
      // Make sure we are called just once if the events
      // are deferred for too long
      delete req.onreadystatechange;

      // Clear the property to allow the request to be
      // garbage collected
      delete that._load_binary_req[url];

      if (abort && abort()) {
        that.loading = false;
        return;
      }

      if (req.status == 200) {
        var uInt8Array;

        if (use_arraybuffer) {
          uInt8Array = new Uint8Array(this.response);
          cb(new BinaryReaderArrayBuffer(uInt8Array), req);
        } else {
          cb(new BinaryReaderString(this.responseText), req);
        }
      } else {
        error("HTTP " + req.status, req);
      }
    } else {
      that._load_binary_req[url].state = req.readyState;
    }
  };

  // Store the request to prevent it from being garbage collected
  // which seems to happen on iOS/Safari
  // the property is deleted in onreadystatechange
  // when we are done with this request
  this._load_binary_req[url] = {
    req: req,
    state: 0,
  };

  req.open(content ? "POST" : "GET", url, true);

  if (use_arraybuffer) {
    req.responseType = "arraybuffer";
  } else if (window.XMLHttpRequest) {
    if (typeof xmlHttpReq !== "undefined" && xmlHttpReq.overrideMimeType) {
      // Fall back to older string hack
      // The following line says we want to receive data as Binary and not as Unicode
      req.overrideMimeType("text/plain; charset=x-user-defined");
    }
  }

  req.send(content ? content : null);
};

Sculpteo3DViewerCommon.prototype.expandBBox = function (bbox, delta) {
  delta = delta || 0.0001;
  var scale = Math.max(
    bbox[1].x - bbox[0].x,
    bbox[1].y - bbox[0].y,
    bbox[1].z - bbox[0].z
  );
  delta *= scale;
  return [
    {
      x: bbox[0].x - delta,
      y: bbox[0].y - delta,
      z: bbox[0].z - delta,
    },
    {
      x: bbox[1].x + delta,
      y: bbox[1].y + delta,
      z: bbox[1].z + delta,
    },
  ];
};

Sculpteo3DViewerCommon.prototype.bboxMesh = function (bbox) {
  var mesh = {};
  var bbox_exp = this.expandBBox(bbox);

  mesh.v = [
    bbox_exp[0].x,
    bbox_exp[0].y,
    bbox_exp[0].z,
    bbox_exp[1].x,
    bbox_exp[0].y,
    bbox_exp[0].z,
    bbox_exp[1].x,
    bbox_exp[1].y,
    bbox_exp[0].z,
    bbox_exp[0].x,
    bbox_exp[1].y,
    bbox_exp[0].z,
    bbox_exp[0].x,
    bbox_exp[0].y,
    bbox_exp[1].z,
    bbox_exp[1].x,
    bbox_exp[0].y,
    bbox_exp[1].z,
    bbox_exp[1].x,
    bbox_exp[1].y,
    bbox_exp[1].z,
    bbox_exp[0].x,
    bbox_exp[1].y,
    bbox_exp[1].z,
  ];

  mesh.f = [
    0, 2, 1, 0, 3, 2, 4, 5, 6, 4, 6, 7, 1, 6, 5, 1, 2, 6, 2, 7, 6, 2, 3, 7, 3,
    4, 7, 3, 0, 4, 0, 5, 4, 0, 1, 5,
  ];

  mesh.face_mi = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
  mesh.face_flag = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  mesh.vertex_count = mesh.v.length / 3;
  mesh.face_count = mesh.f.length / 3;
  mesh.material_count = 0;

  return mesh;
};

Sculpteo3DViewerCommon.prototype.setLoadingComplete = function () {
  this.loading = false;
  this.loading_bbox = false;
  this.$imageDiv.css("opacity", 1.0);
  this.$canvas.css("opacity", 1.0);
};

Sculpteo3DViewerCommon.prototype.fitModelsInView = function () {
  this.resetView();
  this.sceneFlatten();
  this.setZoom(this.bounding_radius / 1.2);
};

Sculpteo3DViewerCommon.prototype.setBbox = function (name, bbox) {
  this.scene.nodes[name].bbox = [
    {
      x: bbox[0],
      y: bbox[1],
      z: bbox[2],
    },
    {
      x: bbox[3],
      y: bbox[4],
      z: bbox[5],
    },
  ];
  this.scene.nodes[name].bboxModel = this.buildModel(
    this.bboxMesh(this.scene.nodes[name].bbox)
  ).vbos;
  this._sceneChanged(false);

  for (var k in this.scene.instances) {
    var instance = this.scene.instances[k];
    var interactive = instance.interactive;

    for (var p = instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }

    if (
      instance.name == name &&
      interactive & Sculpteo3DViewerCommon.INTERACTIVE_BBOX
    ) {
      this.postEvent(
        "node",
        instance.key,
        "bbox",
        "" + bbox[0],
        "" + bbox[1],
        "" + bbox[2],
        "" + bbox[3],
        "" + bbox[4],
        "" + bbox[5]
      );
    }
  }
};

Sculpteo3DViewerCommon.prototype.createModel = function (json, name) {
  var mesh;

  if (!json) {
    mesh = {
      v: [],
      f: [],
      material: [],
    };
  } else {
    mesh = eval("(" + json + ")");
  }

  if (!mesh.material) {
    mesh.material = [];
  }

  mesh.material_count = mesh.material.length;
  mesh.vertex_count = mesh.v.length;
  mesh.face_count = mesh.f.length;

  if (!mesh.scale) {
    mesh.scale = 2.0;
  }

  if (!mesh.center_x) {
    mesh.center_x = 0.0;
  }

  if (!mesh.center_y) {
    mesh.center_y = 0.0;
  }

  if (!mesh.center_z) {
    mesh.center_z = 0.0;
  }

  if (!mesh.minpx) {
    var i;
    var minpx, minpy, minpz, maxpx, maxpy, maxpz;

    if (!mesh.vertex_count) {
      minpx = minpy = minpz = maxpx = maxpy = maxpz = 0.0;
    } else {
      minpx = maxpx = mesh.v[0];
      minpy = maxpy = mesh.v[1];
      minpz = maxpz = mesh.v[2];
    }

    for (var i = 1; i < mesh.vertex_count; i++) {
      if (mesh.v[3 * i + 0] < minpx) {
        minpx = mesh.v[3 * i + 0];
      }

      if (mesh.v[3 * i + 0] > maxpx) {
        maxpx = mesh.v[3 * i + 0];
      }

      if (mesh.v[3 * i + 1] < minpy) {
        minpy = mesh.v[3 * i + 1];
      }

      if (mesh.v[3 * i + 1] > maxpy) {
        maxpy = mesh.v[3 * i + 1];
      }

      if (mesh.v[3 * i + 2] < minpz) {
        minpz = mesh.v[3 * i + 2];
      }

      if (mesh.v[3 * i + 2] > maxpz) {
        maxpz = mesh.v[3 * i + 2];
      }
    }

    mesh.minpx = minpx;
    mesh.minpy = minpy;
    mesh.minpz = minpz;
    mesh.maxpx = maxpx;
    mesh.maxpy = maxpy;
    mesh.maxpz = maxpz;
  }

  var bbox = [
    mesh.minpx,
    mesh.minpy,
    mesh.minpz,
    mesh.maxpx,
    mesh.maxpy,
    mesh.maxpz,
  ];

  var that = this;
  var model = {
    mesh: mesh,
  };

  if (!this.scene.nodes[name]) {
    this.scene.nodes[name] = new Sculpteo3DViewerCommonNode(
      undefined,
      Sculpteo3DViewerCommonTransform3D.identity
    );
    this.scene.nodes[name].name = name;
  }

  this.setBbox(name, bbox);

  $.extend(
    model,
    this.buildModel(mesh, function () {
      that.log(new Date().getTime() / 1000 + " compiled");
      that.__loadModelOnReady.call(that, model, name);
    })
  );
};

Sculpteo3DViewerCommon.prototype.createProceduralModel = function (
  functionname,
  name
) {
  var fn = window[functionname];

  if (!fn) {
    return;
  }

  if (!this.scene.nodes[name]) {
    this.scene.nodes[name] = new Sculpteo3DViewerCommonNode(
      undefined,
      Sculpteo3DViewerCommonTransform3D.identity
    );
    this.scene.nodes[name].name = name;
  }

  this.scene.nodes[name].proc = fn;

  this.updateProceduralMesh(this.scene.nodes[name], name);
};

Sculpteo3DViewerCommon.prototype.__loadModel = function (
  url,
  name,
  content,
  onload,
  onready,
  onerror,
  abort_condition,
  onheaders
) {
  var _this = this;

  //_this.log("download binary model from " + url);
  this.load_binary_resource(
    url,
    content,
    function (mesh_data, req) {
      //_this.log((new Date()).getTime() / 1000. + " downloaded");

      if (onload) {
        onload(req);
      }

      var mesh = new Mesh(mesh_data);

      mesh.decode(
        function () {
          //_this.log((new Date()).getTime() / 1000. + " decoded");
          var model = {
            mesh: mesh,
          };

          $.extend(
            model,
            _this.buildModel(
              mesh,
              function () {
                //_this.log((new Date()).getTime() / 1000. + " compiled");

                if (abort_condition && abort_condition()) {
                  _this.loading = false;
                  return;
                }

                if (onready) {
                  onready.call(_this, model, name);
                }
              },
              onerror,
              abort_condition
            )
          );
        },
        onerror,
        abort_condition
      );
    },
    onerror,
    abort_condition,
    onheaders
  );
};

Sculpteo3DViewerCommon.prototype.__loadModelOnReady = function (model, name) {
  var transform = Sculpteo3DViewerCommonTransform3D.identity;
  var scale = model.mesh.scale * 0.5;
  var tx = model.mesh.center_x;
  var ty = model.mesh.center_y;
  var tz = model.mesh.center_z;
  if (this.scene.nodes[name].bbox) {
    var bbox = this.scene.nodes[name].bbox;
    scale =
      Math.max(
        bbox[1].x - bbox[0].x,
        bbox[1].y - bbox[0].y,
        bbox[1].z - bbox[0].z
      ) * 0.5;
    tx = (bbox[1].x + bbox[0].x) * 0.5;
    ty = (bbox[1].y + bbox[0].y) * 0.5;
    tz = (bbox[1].z + bbox[0].z) * 0.5;
  }
  var s = Sculpteo3DViewerCommonTransform3D.scale(scale, scale, scale);
  var m = Sculpteo3DViewerCommonTransform3D.translation(tx, ty, tz);

  transform = transform.x(m);
  transform = transform.x(s);

  this.scene.nodes[name].model = model.vbos;
  this.scene.nodes[name].leaders = model.leaders;
  this.scene.nodes[name].curves = model.curves;
  this.scene.nodes[name].group = model.mesh.group;
  this.scene.nodes[name].transform = transform;

  if (model.proc) {
    this.scene.nodes[name].proc = model.proc;
  } else {
    this.scene.nodes[name].proc = null;
  }

  if (model.mesh.markups) this.scene.nodes[name].markups = model.mesh.markups;
  if (model.mesh.features)
    this.scene.nodes[name].features = model.mesh.features;

  // Update bbox from model data, but only if we did not
  // find any info from the server, so that if simplification is
  // crappy we still have a chance to get the correct full model bbox
  if (!this.scene.nodes[name].bbox) {
    var minp = transform.x([
      model.mesh.minpx,
      model.mesh.minpy,
      model.mesh.minpz,
      1,
    ]);
    var maxp = transform.x([
      model.mesh.maxpx,
      model.mesh.maxpy,
      model.mesh.maxpz,
      1,
    ]);

    this.setBbox(name, [minp[0], minp[1], minp[2], maxp[0], maxp[1], maxp[2]]);
  }

  // This.scene.nodes[name].material =  material || "global";

  if (name == "model") {
    /* The scene is centered on the model, but we keep the
		true model transform in its node, so that adding other
		nodes is easier (they just need to take care of their own transform,
		instead of composing it with the inverse of the main mesh transform) */
    this.scene_transform = transform.inverse();

    this.mesh = model.mesh;
    this.curves = model.curves;
    this.leaders = model.leaders;
    this.scale = this.mesh.scale;
    this.center_x = this.mesh.center_x;
    this.center_y = this.mesh.center_y;
    this.center_z = this.mesh.center_z;

    this.drawRuler();
    this.drawGrid();

    this.loading = false;
    this.loading_bbox = false;
    this.$imageDiv.css("opacity", 1.0);
    this.$canvas.css("opacity", 1.0);
    this.postEvent("progress", "100");
    this.postEvent("progress", "MODEL_LOADED");
  }

  // Post node progress & load events
  for (var k in this.scene.instances) {
    var instance = this.scene.instances[k];
    var interactive = instance.interactive;

    for (var p = instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }

    if (
      instance.name == name &&
      interactive & Sculpteo3DViewerCommon.INTERACTIVE_PROGRESS
    ) {
      this.postEvent("node", instance.key, "progress", "100");
    }

    if (
      instance.name == name &&
      interactive & Sculpteo3DViewerCommon.INTERACTIVE_LOAD
    ) {
      this.postEvent("node", instance.key, "load", "100");
    }

    if (
      instance.name == name &&
      interactive & Sculpteo3DViewerCommon.INTERACTIVE_GROUPS
    ) {
      if (model.mesh.group) {
        this.postEvent("node", instance.key, "groups", "100");
      }
    }
  }
  this.postEvent("nodeloaded", name);

  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._loadModel = function (
  src,
  content,
  name,
  material
) {
  this.cancelRemote();

  var url = getModelSrc(src, this.viewer_src_type);

  if (typeof src == "undefined" || !url) {
    console.log("No url associated with model: " + name);

    return;
  }

  if (url[0] == "{" || url == "") {
    // JSON
    return this.createModel(url, name);
  }

  if (url.startsWith("javascript:")) {
    // Procedural mesh
    return this.createProceduralModel(url.substr(11), name);
  }

  url +=
    (url.indexOf("?") >= 0 ? "&" : "?") + "viewer=" + this.viewer_remote_type;

  // TODO: handle POST and warnings
  log(new Date().getTime() / 1000 + " load " + name + " " + url);

  var loadid;
  var viewer = this;
  var abort_condition = function () {
    if (name != "model") {
      return false;
    }

    return viewer.loadid != loadid;
  };

  if (name == "model") {
    // Do not cache
    if (!this.render_cache) {
      url += "&_=" + Utils.uniqueString();
    }

    this.mesh = null;
    this.center_x = this.center_y = this.center_z = this.scale = 0.0;
    this.$imageDiv.css("opacity", this.fading ? 0.3 : 0.0);
    this.$canvas.css("opacity", this.fading ? 0.3 : 0.0);
    this.loading = true;
    viewer.loading_bbox = true;
    loadid = ++this.loadid;
  }

  if (!viewer.scene.nodes[name]) {
    viewer.scene.nodes[name] = new Sculpteo3DViewerCommonNode(
      undefined,
      undefined,
      material || "global"
    );
    viewer.scene.nodes[name].name = name;
  }

  // Make sure we clear the old model bbox, so that a new event is generated
  viewer.scene.nodes[name].bbox = null;

  var onerror = function (msg, req) {
    viewer.log(msg);

    if (name == "model") {
      viewer.loading = false;
      viewer.loading_bbox = false;

      viewer.$imageDiv.css("opacity", 1.0);
      viewer.$canvas.css("opacity", 1.0);

      // We use code 409 to indicate outdated data, retry in this case
      if (req.status == 409) {
        log("409 -> interrupted");
        viewer.postEvent("interrupted", url);
        viewer.setUpdate(false);
      } else {
        viewer.postEvent("progress", "0");
        viewer.postEvent("progress", "100");
        viewer.setUpdate(false);
      }
    }

    if (req.status != 409) {
      for (var k in viewer.scene.instances) {
        var instance = viewer.scene.instances[k];
        var interactive = instance.interactive;

        for (var p = instance.parent; p; p = p.parent) {
          interactive |= p.interactive;
        }

        if (
          instance.name == name &&
          interactive & Sculpteo3DViewerCommon.INTERACTIVE_LOADING_ERROR
        ) {
          viewer.postEvent("node", instance.key, "loadingError", msg);
        }
      }
    }
  };

  var bbox;

  if (src && src.bbox) {
    bbox = eval("([" + src.bbox + "])");

    if (bbox) {
      viewer.setBbox(name, bbox);
    }
  }

  var onheaders = function (req) {
    var empty_scene = true;
    // Post node progress events
    for (var k in viewer.scene.instances) {
      var instance = viewer.scene.instances[k];
      var interactive = instance.interactive;

      for (var p = instance.parent; p; p = p.parent) {
        interactive |= p.interactive;
      }

      if (
        instance.name == name &&
        interactive & Sculpteo3DViewerCommon.INTERACTIVE_PROGRESS
      ) {
        viewer.postEvent("node", instance.key, "progress", "0");
      }

      if (instance.name == name) {
        var waitjob = req.getResponseHeader("X-Sculpteo-WaitJob");

        if (waitjob) {
          empty_scene = false;
          if (name == "model") {
            viewer.postEvent("waitJob", waitjob + ";" + url);
          } else {
            viewer.postEvent(
              "node",
              instance.key,
              "waitJob",
              waitjob + ";" + url
            );
          }
        }
      }

      if (
        instance.name == name &&
        (interactive & Sculpteo3DViewerCommon.INTERACTIVE_ERRORMSG ||
          name == "model")
      ) {
        var error = req.getResponseHeader("X-Sculpteo-Message");

        if (error) {
          if (
            name == "model" &&
            !(interactive & Sculpteo3DViewerCommon.INTERACTIVE_ERRORMSG)
          ) {
            viewer.postEvent("errorMessage", error);
          } else {
            viewer.postEvent("node", instance.key, "errorMessage", error);
          }
        }
      }

      if (
        instance.name == name &&
        (interactive & Sculpteo3DViewerCommon.INTERACTIVE_WARNING ||
          name == "model")
      ) {
        var warning = req.getResponseHeader("X-Sculpteo-Warnings");

        if (warning) {
          if (
            name == "model" &&
            !(interactive & Sculpteo3DViewerCommon.INTERACTIVE_WARNING)
          ) {
            viewer.postEvent("warnings", warning);
          } else {
            viewer.postEvent("node", instance.key, "warnings", warning);
          }
        }
      }
    }

    if (url) {
      var uuid_match = url.match(/uuid=([^&]*)/);
      if (uuid_match) {
        viewer.scene.nodes[name].uuid = uuid_match[1];
      }
    }

    if (name == "model") {
      viewer.design_uuid = null;

      if (typeof src == "object" && src.uuid) {
        viewer.design_uuid = src.uuid;
      } else if (url) {
        try {
          viewer.design_uuid = url.split(/uuid=/)[1].split("&")[0];
        } catch (e) {
          console.log("Error : " + e + " with url : " + url);
        }
      }

      viewer.loading_bbox = false;
    }

    var bbox_data = req.getResponseHeader("X-Sculpteo-BBox");

    if (bbox_data) {
      bbox = eval("(" + bbox_data + ")");
    }

    if (bbox) {
      viewer.setBbox(name, bbox);
    }

    // Update scene transform early
    if (name == "model" && bbox) {
      viewer._mesh_bbox = bbox;
      var transform = Sculpteo3DViewerCommonTransform3D.identity;
      var scale = bbox[3] - bbox[0];

      if (bbox[4] - bbox[1] > scale) {
        scale = bbox[4] - bbox[1];
      }

      if (bbox[5] - bbox[2] > scale) {
        scale = bbox[5] - bbox[2];
      }

      scale *= 0.5;
      var tx = 0.5 * (bbox[0] + bbox[3]);
      var ty = 0.5 * (bbox[1] + bbox[4]);
      var tz = 0.5 * (bbox[2] + bbox[5]);
      var s = Sculpteo3DViewerCommonTransform3D.scale(scale, scale, scale);
      var m = Sculpteo3DViewerCommonTransform3D.translation(tx, ty, tz);

      transform = transform.x(m);
      transform = transform.x(s);

      /* The scene is centered on the model, but we keep the
			true model transform in its node, so that adding other
			nodes is easier (they just need to take care of their own transform,
			instead of composing it with the inverse of the main mesh transform) */
      viewer.scene.nodes[name].transform = transform;
      viewer.scene_transform = transform.inverse();
    }

    if (name == "model" && url.indexOf("geometry/cube.svm") > 0) {
      viewer.postEvent("model_cube");
    }

    if (empty_scene) {
      // Remote render
      viewer.scene.nodes[name].model = null;
      viewer._sceneChanged(true);

      viewer.postEvent("progress", "0");
    }
  };

  var onload = function (req) {
    // Post node progress events
    for (var k in viewer.scene.instances) {
      var instance = viewer.scene.instances[k];
      var interactive = instance.interactive;

      for (var p = instance.parent; p; p = p.parent) {
        interactive |= p.interactive;
      }

      if (
        instance.name == name &&
        interactive & Sculpteo3DViewerCommon.INTERACTIVE_PROGRESS
      ) {
        viewer.postEvent("node", instance.key, "progress", "50");
      }
    }
  };

  this.__loadModel(
    url,
    name,
    content,
    onload,
    this.__loadModelOnReady,
    onerror,
    abort_condition,
    onheaders
  );
};

Sculpteo3DViewerCommon.prototype.loadModelPost = function (src, content) {
  this._loadModel(src, content);
};

Sculpteo3DViewerCommon.prototype.loadModel = function (src, id, material) {
  if (typeof id == "undefined") {
    id = "model";
  }

  this._loadModel(src, null, id, material);
};

Sculpteo3DViewerCommon.prototype.getGroups = function (id) {
  if (typeof id == "undefined") {
    id = "model";
  }
  return this.scene.nodes[id].group;
};

Sculpteo3DViewerCommon.prototype.setModel = function (src, id) {
  this.loadModel(src, id);
};

Sculpteo3DViewerCommon.prototype.setAutorotate = function (enable) {
  this.autorotate = enable;

  if (enable) {
    this.lastFrame = +new Date();
  }

  this.setUpdate(false);
};

Sculpteo3DViewerCommon.prototype.toggleAutorotate = function () {
  this.autorotate = !this.autorotate;
  this.setUpdate(false);
};

Sculpteo3DViewerCommon.prototype.setQuality = function (_quality) {
  this.quality = _quality;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setRemoteQuality = function (_remote_quality) {
  this.remote_quality = _remote_quality;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.resetPatchRender = function () {
  //Utils.delCookie("p_render_state", "/");
  //Utils.delCookie("p_render_fill_type", "/");
  //Utils.delCookie("p_render_frequency", "/");
  //Utils.delCookie("p_render_patch_width", "/");
  //Utils.delCookie("p_render_patch_height", "/");
  this.patch_render = 1;
  this.patch_fill_type = 1;
  this.patch_frequency = 0.0;
  this.patch_width = 16;
  this.patch_height = 16;
};

Sculpteo3DViewerCommon.prototype.setPatchRender = function (patch_render) {
  if (patch_render == 1 || patch_render == true) {
    this.patch_render = 1;
    if (this.patch_width == 0 || this.patch_width == false) {
      //Utils.setCookie("p_render_patch_width", "16", 0, "/");
      this.patch_width = 16;
    }
    if (this.patch_height == 0 || this.patch_height == false) {
      //Utils.setCookie("p_render_patch_height", "16", 0, "/");
      this.patch_height = 16;
    }
  } else if (patch_render == 0 || patch_render == false) {
    this.patch_render = 0;
  }
};

Sculpteo3DViewerCommon.prototype.enablePatchRender = function () {
  this.patch_render = 1;
  //Utils.setCookie("p_render_state", "1", 0, "/");
  if (this.patch_width == 0 || this.patch_width == false) {
    //Utils.setCookie("p_render_patch_width", "16", 0, "/");
    this.patch_width = 16; // Maybe set a define for the default size
  }
  if (this.patch_height == 0 || this.patch_height == false) {
    //Utils.setCookie("p_render_patch_height", "16", 0, "/");
    this.patch_height = 16; // Maybe set a define for the default size
  }
};

Sculpteo3DViewerCommon.prototype.disablePatchRender = function () {
  //Utils.setCookie("p_render_state", "0", 0, "/");
  this.patch_render = 0;
};

Sculpteo3DViewerCommon.prototype.setPatchFillType = function (fill_type) {
  //Utils.setCookie("p_render_fill_type", fill_type.toString(), 0, "/");
  this.patch_fill_type = parseInt(fill_type);
};

Sculpteo3DViewerCommon.prototype.setPatchFrequency = function (frequency) {
  if (frequency === "smart") {
    //Utils.setCookie("p_render_frequency", "0.0", 0, "/");
    this.patch_frequency = 0.0;
  } else {
    //Utils.setCookie("p_render_frequency", frequency.toString(), 0, "/");
    this.patch_frequency = parseFloat(frequency);
  }
};

Sculpteo3DViewerCommon.prototype.setPatchWidth = function (p_w) {
  if (p_w) {
    //Utils.setCookie("p_render_patch_width", p_w.toString(), 0, "/");
    this.patch_width = parseInt(p_w);
  }
};

Sculpteo3DViewerCommon.prototype.setPatchHeight = function (p_h) {
  if (p_h) {
    //Utils.setCookie("p_render_patch_height", p_h.toString(), 0, "/");
    this.patch_height = parseInt(p_h);
  }
};

Sculpteo3DViewerCommon.prototype.setPatchSize = function (p_w, p_h) {
  if (p_w && p_h) {
    //Utils.setCookie("p_render_patch_width", p_w.toString(), 0, "/");
    //Utils.setCookie("p_render_patch_height", p_h.toString(), 0, "/");
    this.patch_width = parseInt(p_w);
    this.patch_height = parseInt(p_h);
  }
};

Sculpteo3DViewerCommon.prototype.getPatchRender = function () {
  return this.patch_render;
};

Sculpteo3DViewerCommon.prototype.getPatchFillType = function () {
  return this.patch_fill_type;
};

Sculpteo3DViewerCommon.prototype.getPatchFrequency = function () {
  return this.patch_frequency;
};

Sculpteo3DViewerCommon.prototype.getPatchWidth = function () {
  return this.patch_width;
};

Sculpteo3DViewerCommon.prototype.getPatchHeight = function () {
  return this.patch_height;
};

Sculpteo3DViewerCommon.prototype.getPatchSize = function () {
  var patch_size = [this.patch_width, this.patch_height];
  return patch_size;
};

Sculpteo3DViewerCommon.prototype.setSmoothNormals = function (enable) {
  this.smooth_normals = enable;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setTranslucency = function (enable) {
  this.translucency = enable;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype._parseBumpNoise = function (noise) {
  if (noise.match("^perlin:") == "perlin:") {
    var p = noise.substr(7).split(/,/);

    var pa = p[0];
    var psx = parseFloat(p[1]);
    var psy, psz;

    if (typeof p[2] != "undefined") {
      psy = parseFloat(p[2]);
      psz = parseFloat(p[3]);
    } else {
      psy = psz = psx;
    }

    return {
      amplitude: pa,
      scale_x: psx,
      scale_y: psy,
      scale_z: psz,
    };
  } else {
    return null;
  }
};

Sculpteo3DViewerCommon.prototype.setBumpNoise = function (noise) {
  this.perlin_val = this._parseBumpNoise(noise);
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setGaussNoise = function (noise) {
  this.gauss_val = noise;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setEnvmap = function (enable) {
  this.envmap = enable;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setForceNodeMap = function (enable) {
  this.forceNodeMap = enable;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.lockDisplay = function (lock) {
  this.locked = lock;
  this.setUpdate(false);
};

Sculpteo3DViewerCommon.prototype.clrCutX = function () {
  this.cutX = null;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setDoubleCut = function (x, y, z, min, max) {
  this.cutAxis = {
    x: x,
    y: y,
    z: z,
    w: min,
  };
  this.doubleCut = max;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.clrDoubleCut = function () {
  this.cutAxis = null;
  this.doubleCut = undefined;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setCutAxis = function (x, y, z, w) {
  this.cutAxis = {
    x: x,
    y: y,
    z: z,
    w: w,
  };
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.clrCutAxis = function () {
  this.cutAxis = null;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.clrCutColor = function () {
  this.cutColor = null;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setCutColor = function (
  r,
  g,
  b,
  margin,
  back_r,
  back_g,
  back_b
) {
  this.cutColor = {
    r: r,
    g: g,
    b: b,
    margin: margin,
    back_r: back_r,
    back_g: back_g,
    back_b: back_b,
  };
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.clrCutColor = function () {
  this.cutColor = null;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setCutX = function (min, max, thickness) {
  this.cutX = {
    min: min,
    max: max,
    thickness: thickness,
  };
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.clrCutY = function () {
  this.cutY = null;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setCutY = function (min, max, thickness) {
  this.cutY = {
    min: min,
    max: max,
    thickness: thickness,
  };
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.clrCutZ = function () {
  this.cutZ = null;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setCutZ = function (min, max, thickness) {
  this.cutZ = {
    min: min,
    max: max,
    thickness: thickness,
  };
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setCSGMode = function (mode) {
  this.csg_mode = mode;
  this.cancelRemote();
  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype.setPerspective = function (enable) {
  this.use_perspective = enable;
  this.updateProjectionMatrix();
  this.cancelRemote();
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setWireframe = function (enable) {
  this.wireframe = enable;
  this.cancelRemote();
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setPointCloud = function (enable) {
  this.pointcloud = enable;
  this.cancelRemote();
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setOrientation = function (enable) {
  this.orientation = enable;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setIssues = function (enable) {
  this.issues = enable;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setSelectedFaces = function (enable) {
  this.selectedfaces = enable;
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setUnits = function (unit) {
  this.mm_scale = unit;
  this.drawRuler();
  this.drawGrid();
};

Sculpteo3DViewerCommon.prototype.setRenderCache = function (enable) {
  this.render_cache = enable;
};

Sculpteo3DViewerCommon.prototype.setSelectionColor = function (r, g, b, a) {
  this.selcolor = { r: r, g: g, b: b, a: a };
};

Sculpteo3DViewerCommon.prototype.setBackgroundColor = function (r, g, b) {
  this.bgcolor = this.color3b_to_html(r, g, b);
  this.jself.css("background-color", this.bgcolor);
};

Sculpteo3DViewerCommon.prototype.setBackgroundImage = function (imageUrl) {
  $(".Sculpteo3DViewerBackgroundImage", this.jself)
    .attr("src", imageUrl)
    .show();
};

Sculpteo3DViewerCommon.prototype.unsetBackgroundImage = function () {
  $(".Sculpteo3DViewerBackgroundImage", this.jself).attr("src", "").hide();
};

Sculpteo3DViewerCommon.prototype.setFading = function (enable) {
  this.fading = enable;
};

Sculpteo3DViewerCommon.prototype.setSolidity = function (
  min_solidity,
  max_solidity
) {
  this.solidity = [min_solidity, max_solidity];
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setSliced = function (dx, dy, dz) {
  this.sliced = [dx, dy, dz];
  this.setUpdate(true);
};

Sculpteo3DViewerCommon.prototype.setdisable3D = function (disable) {
  if (disable) {
    this.mouse_disabled = true;

    if (this.hideControls) {
      this.hideControls();
    }

    this.$imageDiv.hide();
    this.$canvas.hide();
    this.disable3D = true;
    this.drawRuler();
    this.drawGrid();
    this.cancelRemote();
  } else {
    if (this.showControls) {
      this.showControls();
    }

    this.mouse_disabled = false;
    this.disable3D = false;
    this.setUpdate(false);
    this.drawRuler();
    this.drawGrid();
    this.$imageDiv.show();
    this.$canvas.show();
  }
};

Sculpteo3DViewerCommon.prototype.mouseInit = function () {
  this.MSTouchCount = 0;

  if (typeof RightClick != "undefined") {
    RightClick.cleanup();
  }

  this.jself[0].setAttribute("tabIndex", -1);
  this.jself.unbind("keypress").bind("keypress", this, this.keypress);
  this.jself.unbind("keydown").bind("keydown", this, this.keyDown);
  this.jself.unbind("keyup").bind("keyup", this, this.keyUp);
  this.jself.unbind("mousedown").bind("mousedown", this, this.mouseDown);
  this.jself.unbind("mousemove").bind("mousemove", this, this.mouseMove);
  this.jself.unbind("mouseup").bind("mouseup", this, this.mouseUp);
  this.jself.unbind("mouseleave").bind("mouseleave", this, this.mouseOut);
  this.jself.unbind("click").bind("click", this, this.mouseClick);

  if (typeof Hammer !== "undefined") {
    this.hammer = new Hammer(this.jself[0]);
    this.hammer.get("pinch").set({ enable: true });

    this.hammerPanLastX = 0;
    this.hammerPanLastY = 0;
    this.hammerScaleLast = 1.0;

    function resetHammerVars() {
      this.hammerPanLastX = 0;
      this.hammerPanLastY = 0;
      this.hammerScaleLast = 1.0;
    }

    function handleHammerPan(ev) {
      var dx = ev.deltaX - this.hammerPanLastX;
      var dy = ev.deltaY - this.hammerPanLastY;
      this.hammerPanLastX = ev.deltaX;
      this.hammerPanLastY = ev.deltaY;

      this.handlePan(dx, dy);
    }

    function handleHammerZoom(ev) {
      var dzoom = ev.scale / this.hammerScaleLast;
      this.hammerScaleLast = ev.scale;
      this.handleZoom(1 / dzoom);
    }

    this.hammer.on(
      "pinchstart",
      function (ev) {
        resetHammerVars.apply(this);
      }.bind(this)
    );

    this.hammer.on(
      "pinch",
      function (ev) {
        if (ev.pointerType !== "touch") {
          return;
        }
        handleHammerZoom.apply(this, [ev]);
        handleHammerPan.apply(this, [ev]);
      }.bind(this)
    );
  }

  if (window.navigator.msPointerEnabled && typeof MSGesture !== "undefined") {
    var _this = this;

    // IE Pointer Events
    var MSelem = _this.jself[0];
    var myGesture = new MSGesture();

    myGesture.target = MSelem;
    _this.jself.bind("MSGestureChange", _this, _this.gestureChange);
    _this.jself.bind("MSGestureStart", _this, _this.gestureStart);
    _this.jself.bind("MSGestureEnd", _this, _this.gestureEnd);
    MSelem.addEventListener("pointerdown", function (evt) {
      myGesture.addPointer(evt.pointerId);
      _this.MSTouchCount++;
    });

    MSelem.addEventListener("pointermove", function (evt) {
      myGesture.addPointer(evt.pointerId);
    });

    MSelem.addEventListener("pointerup", function (evt) {
      myGesture.addPointer(evt.pointerId);
      _this.MSTouchCount--;
    });

    _this.touch_device = true;
  }

  this.jself.bind("touchstart", this, this.mouseDown);
  this.jself.bind("touchend", this, this.mouseUp);
  this.jself.bind("touchmove", this, this.mouseMove);
  this.jself.bind("gesturestart", this, this.gestureStart);
  this.jself.bind("gesturechange", this, this.gestureChange);
  this.jself.bind("gestureend", this, this.gestureEnd);
  if (this.isTouchDevice()) {
    this.touch_device = true;
  }

  if (typeof this.touch_device === "undefined") {
    this.touch_device = false;
  }

  var _this = this;

  _this.jself.off("mousewheel").on("mousewheel", _this, _this.mouseWheel);

  this.mouse_x = this.mouse_y = 0;
  this.mousedown_x = this.mousedown_y = 0;
  this.mouselast_x = this.mouselast_y = 0;
  this.mousedown = new Array();
};

Sculpteo3DViewerCommon.prototype.postEvent = function () {
  var args = Array.prototype.slice.call(arguments);
  var that = this;

  if (!this.evq) {
    this.evq = [];
  }

  this.evq.push(args);

  if (this.evqTimeout) {
    clearTimeout(this.evqTimeout);
  }

  this.evqTimeout = setTimeout(function () {
    // Event handlers may themselves post events, be careful with that
    var evq = that.evq;

    while (evq.length) {
      that.evq = [];

      for (var k = 0; k < evq.length; k++) {
        that.eventHandler.apply(window, evq[k]);
      }

      evq = that.evq;
    }
  }, 0);
};

// Convert scene to array of nodes to render
// a scene contains named nodes, and a CSG tree starting at scene.root
// nodes in this tree are either models or operations
Sculpteo3DViewerCommon.prototype._sceneFlattenNode = function (
  node,
  transform,
  mode
) {
  if (!node) {
    return [];
  }

  if (typeof node.name != "undefined") {
    transform = transform.x(node.transform);

    var n = this.scene.nodes[node.name];

    transform = transform.x(n.transform);

    if (n != "undefined") {
      // Compute an effective drawmode depending on current model availability
      drawmode = node.drawmode;

      if (typeof n.model == "undefined") {
        // Render the bbox while loading the model
        drawmode &= ~Sculpteo3DViewerCommon.DRAWMODE_FLAT;
        drawmode |= Sculpteo3DViewerCommon.DRAWMODE_BBOX;
      } else if (
        this.csg_mode == Sculpteo3DViewerCommon.CSG_MODE_NONE &&
        mode != 1
      ) {
        // Render in wireframe if we don't support CSG
        drawmode &= ~Sculpteo3DViewerCommon.DRAWMODE_FLAT;
        drawmode |= Sculpteo3DViewerCommon.DRAWMODE_WIREFRAME;
      }

      return [
        new Sculpteo3DViewerCommonNode(
          n.model,
          transform,
          node.material,
          node.group,
          node.opacity,
          n,
          node,
          drawmode
        ),
      ];
    } else {
      return [];
    }
  }

  // Only union/append supported so far, intersection and difference are shown as union
  // until CSG rendering is supported
  if (typeof node.operation != "undefined") {
    if (
      node.operation == "union" ||
      node.operation == "append" ||
      node.operation == "intersection" ||
      node.operation == "difference" ||
      node.operation == "measurement"
    ) {
      transform = transform.x(node.transform);

      var nodes_A, nodes_B;

      switch (node.operation) {
        case "union":
        case "measurement":
          nodes_A = this._sceneFlattenNode(node.A, transform, mode);
          nodes_B = this._sceneFlattenNode(node.B, transform, mode);
          break;
        case "intersection":
          nodes_A = this._sceneFlattenNode(node.A, transform, 0);
          nodes_B = this._sceneFlattenNode(node.B, transform, 0);
          break;
        case "difference":
          nodes_A = this._sceneFlattenNode(node.A, transform, mode);
          nodes_B = this._sceneFlattenNode(node.B, transform, -mode);
          break;
      }

      return nodes_A.concat(nodes_B);
    }
  }

  return [];
};

Sculpteo3DViewerCommon.prototype.sceneFlatten = function () {
  var nodes = this._sceneFlattenNode(
    this.scene.root,
    this.scene.root.transform,
    1
  );

  // Update near and far values
  // XXX: should be done only once per scene update / model ready / ui change
  var bounding_center = [0.0, 0.0, 0.0];
  var bounding_radius = 0.0;
  var shadow_bounding_center = null;
  var shadow_bounding_radius = 0.0;

  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];

    if (typeof node == "undefined") {
      continue;
    }

    var M = this.scene_transform.x(node.transform);

    // Initial model is in [-1,1]^3, compute bounding sphere radius and center
    var origin = [0, 0, 0, 1];
    var X = [1, 0, 0, 0];
    var Y = [0, 1, 0, 0];
    var Z = [0, 0, 1, 0];

    origin = M.x(origin);
    X = M.x(X);
    Y = M.x(Y);
    Z = M.x(Z);
    var D = [X[0] + Y[0] + Z[0], X[1] + Y[1] + Z[1], X[2] + Y[2] + Z[2]];
    var r = Math.sqrt(D[0] * D[0] + D[1] * D[1] + D[2] * D[2]); // Diagonal
    var cx = origin[0] / origin[3];
    var cy = origin[1] / origin[3];
    var cz = origin[2] / origin[3];
    var center = [cx, cy, cz];

    // Log("bsphere center="+ cx + "," + cy + "," + cz + " radius=" + r);

    // Merge
    var d = [
      center[0] - bounding_center[0],
      center[1] - bounding_center[1],
      center[2] - bounding_center[2],
    ];
    var dist2 = d[0] * d[0] + d[1] * d[1] + d[2] * d[2];

    if ((r - bounding_radius) * (r - bounding_radius) >= dist2) {
      // Totally enclosed
      if (r > bounding_radius) {
        bounding_radius = r;
        bounding_center = center;
      }
    } else {
      var dist = Math.sqrt(dist2);

      bounding_radius = (dist + bounding_radius + r) * 0.5;
      bounding_center = center;

      if (dist > 1e-3) {
        var s = (r - bounding_radius) / dist;

        bounding_center[0] = center[0] + d[0] * s;
        bounding_center[1] = center[1] + d[1] * s;
        bounding_center[2] = center[2] + d[2] * s;
      }
    }

    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }

    var vbos = node.model;

    if (!vbos) {
      continue;
    }

    if (shadow_bounding_center == null) {
      shadow_bounding_center = [center[0], center[1], center[2]];
    }

    var d = [
      center[0] - shadow_bounding_center[0],
      center[1] - shadow_bounding_center[1],
      center[2] - shadow_bounding_center[2],
    ];
    var dist2 = d[0] * d[0] + d[1] * d[1] + d[2] * d[2];

    if ((r - shadow_bounding_radius) * (r - shadow_bounding_radius) >= dist2) {
      // Totally enclosed
      if (r > shadow_bounding_radius) {
        shadow_bounding_radius = r;
        shadow_bounding_center = center;
      }
    } else {
      var dist = Math.sqrt(dist2);

      shadow_bounding_radius = (dist + bounding_radius + r) * 0.5;
      shadow_bounding_center = center;

      if (dist > 1e-3) {
        var s = (r - shadow_bounding_radius) / dist;

        shadow_bounding_center[0] = center[0] + d[0] * s;
        shadow_bounding_center[1] = center[1] + d[1] * s;
        shadow_bounding_center[2] = center[2] + d[2] * s;
      }
    }
  }

  if (this.ui && this.ui.cursorNode) {
    // Cursor mesh may be anywhere on the surface of the existing scene
    // so simply add its radius
    var node = this.ui.cursorNode;

    // Var M = this.scene_transform.x(node.transform);
    var M = node.transform;
    var X = [1, 0, 0, 0];
    var Y = [0, 1, 0, 0];
    var Z = [0, 0, 1, 0];

    X = M.x(X);
    Y = M.x(Y);
    Z = M.x(Z);
    var D = [X[0] + Y[0] + Z[0], X[1] + Y[1] + Z[1], X[2] + Y[2] + Z[2]];
    var r = Math.sqrt(D[0] * D[0] + D[1] * D[1] + D[2] * D[2]);

    // Diagonal
    bounding_radius += r;

    if (node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT) {
      var vbos = node.model;

      if (vbos) {
        shadow_bounding_radius += r;
      }
    }
  }

  bounding_radius += Math.sqrt(
    bounding_center[0] * bounding_center[0] +
      bounding_center[1] * bounding_center[1] +
      bounding_center[2] * bounding_center[2]
  );

  // Log("bounding radius=" + bounding_radius);

  this.bounding_radius = bounding_radius;

  // shadow_bounding_radius += Math.sqrt(shadow_bounding_center[0] * shadow_bounding_center[0] + shadow_bounding_center[1] * shadow_bounding_center[1] + shadow_bounding_center[2] * shadow_bounding_center[2]);

  this.shadow_bounding_radius = shadow_bounding_radius;

  // View dependent version
  // Var near = -bounding_center[2] - bounding_radius;
  // Var far = -bounding_center[2] + bounding_radius;

  var near = -bounding_radius;
  var far = bounding_radius;

  this.nearVal = near;
  this.farVal = far;
  this.updateProjectionMatrix();

  return nodes;
};

// Normalize the CSG tree to a sum of products, see
// "Near Real-Time CSG rendering using Tree Normalization and Geometric Pruning" by J.Goldfeather et al.
Sculpteo3DViewerCommon.prototype._sceneCSGTreeMatchAndReplace = function (
  node
) {
  var x, y, z;

  // 1. x - (y + z) -> (x - y) - z
  if (node.operation == "difference" && node.B.operation == "union") {
    x = node.A;
    y = node.B.A;
    z = node.B.B;
    node.operation = "difference";
    node.A = {
      operation: "difference",
      A: x,
      B: y,
    };
    node.B = z;

    return true;
  }

  // 2. x * (y + z) -> (x * y) + (x * z)
  if (node.operation == "intersection" && node.B.operation == "union") {
    x = node.A;
    y = node.B.A;
    z = node.B.B;
    node.operation = "union";
    node.A = {
      operation: "intersection",
      A: x,
      B: y,
    };
    node.B = {
      operation: "intersection",
      A: x,
      B: z,
    };

    return true;
  }

  // 3. x - (y * z) -> (x - y) + (x - z)
  if (node.operation == "difference" && node.B.operation == "intersection") {
    x = node.A;
    y = node.B.A;
    z = node.B.B;
    node.operation = "union";
    node.A = {
      operation: "difference",
      A: x,
      B: y,
    };
    node.B = {
      operation: "difference",
      A: x,
      B: z,
    };

    return true;
  }

  // 4. x * (y * z) -> (x * y) * z
  if (node.operation == "intersection" && node.B.operation == "intersection") {
    x = node.A;
    y = node.B.A;
    z = node.B.B;
    node.operation = "intersection";
    node.A = {
      operation: "intersection",
      A: x,
      B: y,
    };
    node.B = z;

    return true;
  }

  // 5. x - (y - z) -> (x - y) + (x * z)
  if (node.operation == "difference" && node.B.operation == "difference") {
    x = node.A;
    y = node.B.A;
    z = node.B.B;
    node.operation = "union";
    node.A = {
      operation: "difference",
      A: x,
      B: y,
    };
    node.B = {
      operation: "intersection",
      A: x,
      B: z,
    };

    return true;
  }

  // 6. x * (y - z) -> (x * y) - z
  if (node.operation == "intersection" && node.B.operation == "difference") {
    x = node.A;
    y = node.B.A;
    z = node.B.B;
    node.operation = "difference";
    node.A = {
      operation: "intersection",
      A: x,
      B: y,
    };
    node.B = z;

    return true;
  }

  // 7. (x - y) * z -> (x * z) - y
  if (node.operation == "intersection" && node.A.operation == "difference") {
    x = node.A.A;
    y = node.A.B;
    z = node.B;
    node.operation = "difference";
    node.A = {
      operation: "intersection",
      A: x,
      B: z,
    };
    node.B = y;

    return true;
  }

  // 8. (x + y) - z -> (x - z) + (y - z)
  if (node.operation == "difference" && node.A.operation == "union") {
    x = node.A.A;
    y = node.A.B;
    z = node.B;
    node.operation = "union";
    node.A = {
      operation: "difference",
      A: x,
      B: z,
    };
    node.B = {
      operation: "difference",
      A: y,
      B: z,
    };

    return true;
  }

  // 9. (x + y) * z -> (x * z) + (y * z)
  if (node.operation == "intersection" && node.A.operation == "union") {
    x = node.A.A;
    y = node.A.B;
    z = node.B;
    node.operation = "union";
    node.A = {
      operation: "intersection",
      A: x,
      B: z,
    };
    node.B = {
      operation: "intersection",
      A: y,
      B: z,
    };

    return true;
  }

  return false;
};

Sculpteo3DViewerCommon.prototype._sceneCSGTreeNormalize = function (node) {
  if (!node) {
    return;
  }

  if (!node.operation) {
    return; // Primitive
  }

  while (true) {
    // Repeat
    while (this._sceneCSGTreeMatchAndReplace(node)) {
      // Normalize the CSG tree to a sum of products
    }

    this._sceneCSGTreeNormalize(node.A);

    if (
      node.operation == "union" ||
      (!node.B.operation && node.A.operation != "union")
    ) {
      break;
    }
  }

  this._sceneCSGTreeNormalize(node.B);
};

Sculpteo3DViewerCommon.prototype._sceneCSGReferenceTree = function (node) {
  if (!node) {
    return;
  }

  if (typeof node.name != "undefined") {
    var n = this.scene.nodes[node.name];

    if (n != "undefined") {
      return this._sceneCSGReferenceCount++;
    } else {
      return;
    }
  }

  if (node.operation) {
    return {
      operation: node.operation,
      A: this._sceneCSGReferenceTree(node.A),
      B: this._sceneCSGReferenceTree(node.B),
    };
  }
};

Sculpteo3DViewerCommon.prototype._sceneCSGSumOfProducts = function (node) {
  if (!node) {
    return;
  }

  if (!node.operation) {
    return [node];
  }

  var a, b;

  a = this._sceneCSGSumOfProducts(node.A);
  b = this._sceneCSGSumOfProducts(node.B);

  if (node.operation == "union") {
    if (node.A.operation == "union") {
      if (node.B.operation == "union") {
        return a.concat(b);
      } else {
        return a.concat([b]);
      }
    } else {
      if (node.B.operation == "union") {
        return [a].concat(b);
      } else {
        return [a, b];
      }
    }
  } else if (node.operation == "intersection") {
    // Intersections always appear below unions
    return a.concat(b);
  } else if (node.operation == "difference") {
    // Differences are always just before a leaf
    return a.concat([-b[0]]);
  }
};

Sculpteo3DViewerCommon.prototype.sceneCSGSumOfProducts = function () {
  // References start from 1, negative indices indicate inversion for difference
  this._sceneCSGReferenceCount = 1;

  // Get a tree of references to node list
  var reftree = this._sceneCSGReferenceTree(this.scene.root);

  // Normalize the tree to disjunctive normal form
  this._sceneCSGTreeNormalize(reftree);

  // Flatten the normalized tree to a list of sums of products
  return this._sceneCSGSumOfProducts(reftree);
};

Sculpteo3DViewerCommon.prototype.createNode = function (
  nodename,
  transform,
  material,
  flags
) {
  if (!nodename) {
    throw new Error("undefined nodename");
  }

  var node = this.scene.nodes[nodename];

  if (!node) {
    // Create an empty node
    node = new Sculpteo3DViewerCommonNode(
      undefined,
      Sculpteo3DViewerCommonTransform3D.identity
    );
    node.name = nodename;
    this.scene.nodes[nodename] = node;
  }

  var key = "";

  for (var i = 0; i < 32; i++) {
    key += ((Math.random() * 16) | 0).toString(16);
  }

  if (transform) {
    transform = new Sculpteo3DViewerCommonTransform3D(transform);
  } else {
    transform = Sculpteo3DViewerCommonTransform3D.identity;
  }

  var instance = {
    name: nodename,
    transform: transform,
    material: material || "global",
    flags: flags,
    key: key,
    children: 0,
  };

  this.scene.instances[key] = instance;

  var bbox = this.scene.nodes[nodename].bbox;
  if (bbox) {
    this.postEvent(
      "node",
      key,
      "bbox",
      "" + bbox[0].x,
      "" + bbox[0].y,
      "" + bbox[0].z,
      "" + bbox[1].x,
      "" + bbox[1].y,
      "" + bbox[1].z
    );
  }

  var model = this.scene.nodes[nodename].model;
  if (model) {
    this.postEvent("node", key, "progress", "100");
  }

  return key;
};

Sculpteo3DViewerCommon.prototype.deleteNode = function (key) {
  if (!key) {
    return;
  }

  if (!this.scene.instances[key]) {
    throw new Error("Node instance not found: " + key);
  }

  delete this.scene.instances[key];

  //this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype.deleteNodeModel = function (nodename) {
  if (!nodename) {
    throw new Error("undefined nodename");
  }

  var node = this.scene.nodes[nodename];

  if (!node) {
    return;
  }

  var toDelete = [];
  for (var i in this.scene.instances) {
    var instance = this.scene.instances[i];
    if (instance["name"] == nodename) {
      toDelete.push(i);
    }
  }
  for (var i = 0; i < toDelete.length; ++i) {
    delete this.scene.instances[toDelete[i]];
  }

  delete this.scene.nodes[nodename];
};

Sculpteo3DViewerCommon.prototype.nodesReset = function () {
  for (var i in this.scene.nodes) {
    if (i !== "root") {
      this.deleteNodeModel(i);
    }
  }
};

Sculpteo3DViewerCommon.prototype.sceneReset = function () {
  delete this.scene.root;
  this.scene.instances = {};
  var rootkey = this.createNode("root");

  this.scene.root = this.scene.instances[rootkey];

  this._sceneChanged(true);

  return rootkey;
};

Sculpteo3DViewerCommon.prototype._sceneUpdate = function () {
  // Hook to indicate scene changed
  this.scene_flat = this.sceneFlatten();
  this.scene_csg = this.sceneCSGSumOfProducts();

  // Cache a mask of things we need to draw to
  // avoid unnecessary draw state changes
  var scene_drawmask = 0;

  for (var k = 0; k < this.scene_flat.length; k++) {
    scene_drawmask |= this.scene_flat[k].drawmode;
  }

  this.scene_drawmask = scene_drawmask;

  // Determine if we need a node map or not
  var nodemap = this.forceNodeMap;

  if (!nodemap) {
    var mask =
      Sculpteo3DViewerCommon.INTERACTIVE_MOVE |
      Sculpteo3DViewerCommon.INTERACTIVE_MOUSEENTER |
      Sculpteo3DViewerCommon.INTERACTIVE_MOUSELEAVE |
      Sculpteo3DViewerCommon.INTERACTIVE_MOUSEDOWN |
      Sculpteo3DViewerCommon.INTERACTIVE_CLICK;

    for (var k = 0; k < this.scene_flat.length; k++) {
      var node = this.scene_flat[k];
      var interactive = node.instance.interactive;

      for (p = node.instance.parent; p; p = p.parent) {
        interactive |= p.interactive;
      }

      if (interactive & mask) {
        nodemap = true;
      }
    }
  }

  this.nodemap = nodemap;

  var tr = this.getSceneTransform();

  tr = new Sculpteo3DViewerCommonTransform3D(tr);
  var comp = tr.decompose();

  this.scene_scale = comp.scale;
};

Sculpteo3DViewerCommon.prototype._sceneChanged = function (render_dirty) {
  // Hook to indicate scene changed
  this.scene_flat = null;
  this.setUpdate(render_dirty);
};

Sculpteo3DViewerCommon.prototype.setCursorNode = function (node_key) {
  var node = this.scene.instances[node_key];

  if (node) {
    this.ui.cursorNode = node;
  } else {
    this.ui.cursorNode = null;
  }
  this.setUpdate(false);
};

Sculpteo3DViewerCommon.prototype.setDraggedNode =
  Sculpteo3DViewerCommon.prototype.setCursorNode;

Sculpteo3DViewerCommon.prototype.getTransformAtLocation = function (mx, my) {
  var x = ((2.0 * mx) / (this.width - 1.0) - 1.0) * this.zoomx;
  var y = ((2.0 * my) / (this.height - 1.0) - 1.0) * -this.zoomy;

  // Reconstruct position and normal at that location
  var dn = this.depthAndNormalAtLocation(x, y);

  if (dn == null) {
    return null;
  }

  var z = dn.z; // + 0.01;
  var nx, ny, nz;

  nx = dn.nx;
  ny = dn.ny;
  nz = dn.nz;

  // 3D transform
  var upx = 0.0;
  var upy = 1.0;
  var upz = 0.0;
  var Zx = nx;
  var Zy = ny;
  var Zz = nz;

  // X=normalize(cross(up, n))
  var Zcupx = Zy * upz - upy * Zz;
  var Zcupy = Zz * upx - upz * Zx;
  var Zcupz = Zx * upy - upx * Zy;
  var l = Math.sqrt(Zcupx * Zcupx + Zcupy * Zcupy + Zcupz * Zcupz);
  var Xx = -Zcupx / l;
  var Xy = -Zcupy / l;
  var Xz = -Zcupz / l;

  // Y=cross(Z, X)
  var Yx = ny * Xz - Xy * nz;
  var Yy = nz * Xx - Xz * nx;
  var Yz = nx * Xy - Xx * ny;

  var T = new Sculpteo3DViewerCommonTransform3D([
    Xx,
    Yx,
    Zx,
    0.0,
    Xy,
    Yy,
    Zy,
    0.0,
    Xz,
    Yz,
    Zz,
    0.0,
    0.0,
    0.0,
    0.0,
    1.0,
  ]);

  var pos = this.unproject([mx, my, z, 1.0]);

  var tMatrix = T;

  tMatrix = Sculpteo3DViewerCommonTransform3D.translation(
    pos[0],
    pos[1],
    pos[2]
  ).x(tMatrix);

  return tMatrix;
};

Sculpteo3DViewerCommon.prototype.getCursorTransform = function (mx, my) {
  var tMatrix = this.getTransformAtLocation(mx, my);

  if (!tMatrix) {
    return null;
  }

  // In object space
  var iCam = this.cameraMat.inverse();
  var iMvMatrix = iCam.x(this.mvMatrix).inverse();

  tMatrix = iMvMatrix.x(tMatrix);
  tMatrix = tMatrix.removeScale();

  return tMatrix.toString();
};

Sculpteo3DViewerCommon.prototype.getCursorNormal = function (mx, my) {
  var x = ((2.0 * mx) / (this.width - 1.0) - 1.0) * this.zoomx;
  var y = ((2.0 * my) / (this.height - 1.0) - 1.0) * -this.zoomy;

  // Reconstruct position and normal at that location
  var dn = this.depthAndNormalAtLocation(x, y);

  if (!dn) {
    return null;
  }

  var n = [dn.nx, dn.ny, dn.nz, 0];
  var iCam = this.cameraMat.inverse();
  var iMvMatrix = iCam.x(this.mvMatrix).inverse();

  return Sculpteo3DViewerCommonTransform3D.vectNormalize(
    iMvMatrix.transformVect(n)
  );
};

// Compute the 3D cursor location in the scene
Sculpteo3DViewerCommon.prototype.getCursorInstance = function (x, y) {
  var node = this.ui.cursorNode;

  if (!node) {
    return;
  }

  if (typeof node.name == "undefined") {
    return;
  }

  var n = this.scene.nodes[node.name];

  if (typeof n == "undefined" || typeof n.model == "undefined") {
    return;
  }

  if (!x || !y) {
    x = this.mouse_x;
    y = this.mouse_y;
  }

  var trans = this.getTransformAtLocation(x, y);

  if (trans == null) {
    return;
  }

  var iCam = this.cameraMat.inverse();
  var iMvMatrix = iCam.x(this.mvMatrix).inverse();

  trans = iMvMatrix.x(trans);

  trans = trans.removeScale();
  trans = trans.x(node.transform);
  trans = trans.x(n.transform);

  return new Sculpteo3DViewerCommonNode(
    n.model,
    trans,
    node.material,
    node.group,
    node.opacity,
    n,
    node
  );
};

Sculpteo3DViewerCommon.prototype.unproject = function (v) {
  // Transform to clip space
  var xn = (2.0 * v[0]) / (this.width - 1.0) - 1.0;
  var yn = -((2.0 * v[1]) / (this.height - 1.0) - 1.0);

  // Unproject Z to clip space so that X and Y can be unprojected
  var A = this.pMatrix.matrix.e(3, 3);
  var B = this.pMatrix.matrix.e(3, 4);
  var z = v[2] + this.cameraZ;
  var zn = -(A * z + B) / z;

  // Unproject from clip space to eye space
  var vi = this.invProjCamMatrix.x([xn, yn, zn, 1.0]);
  var xu = vi[0] / vi[3];
  var yu = vi[1] / vi[3];

  return [xu, yu, v[2], 1.0];
};

Sculpteo3DViewerCommon.prototype._scene_log = function () {
  var scene_to_string = function (node, transform) {
    if (node.transform) {
      transform = transform.x(node.transform);
    }

    if (node.operation) {
      var A = scene_to_string(node.A, transform);
      var B = scene_to_string(node.B, transform);

      if (A && B) {
        return "(" + A + " " + node.operation + " " + B + ")";
      } else if (A) {
        return A;
      } else if (B) {
        return B;
      } else {
        return "";
      }
    } else if (node.name) {
      return node.name + "[material=" + node.material + "]";
    } else {
      return "";
    }
  };

  var str = scene_to_string(this.scene.root, this.scene.root.transform);

  log(str);
};

Sculpteo3DViewerCommon.prototype._moveUpTree = function (node_instance) {
  // Move up the operation tree
  // to the root operation of the child group
  var children = node_instance.children;

  while (children && node_instance.parent) {
    node_instance = node_instance.parent;
    children--;
  }

  return node_instance;
};

Sculpteo3DViewerCommon.prototype.forEachNode = function (callback) {
  for (k in this.scene.nodes) {
    var node = this.scene.nodes[k];
    if (node.model && node.uuid) callback(node);
  }
};

Sculpteo3DViewerCommon.prototype._attachNode = function (
  parent_key,
  child_key,
  op
) {
  if (!op) {
    op = "union";
  }

  /*Var op2;
	if(op = 'measurement') op2 = 'union';
	else op2 = op;*/

  var op_node = {
    operation: op,
    transform: new Sculpteo3DViewerCommonTransform3D(),
  }; // TODO: nicer class

  var parent_instance = this.scene.instances[parent_key];
  var child_instance = this.scene.instances[child_key];

  /* Increase child count and move up the operation tree
	to the root operation of the current parent group*/
  var children = parent_instance.children;

  parent_instance.children++;

  while (children && parent_instance.parent) {
    parent_instance = parent_instance.parent;
    children--;
  }

  op_node.A = parent_instance; // Left subtree is the current group

  // Move up the operation tree
  // to the root operation of the child group
  child_instance = this._moveUpTree(child_instance);

  op_node.B = child_instance; // Right subtree is the new child group

  // Move the current group transform up
  op_node.transform = parent_instance.transform;
  op_node.interactive = parent_instance.interactive;
  op_node.material = parent_instance.material;
  op_node.opacity = parent_instance.opacity;
  op_node.drawmode = parent_instance.drawmode;
  op_node.bboxColor = parent_instance.bboxColor;
  op_node.wireframeColor = parent_instance.wireframeColor;
  op_node.flags = parent_instance.flags;

  parent_instance.transform = new Sculpteo3DViewerCommonTransform3D();

  // Insert the new operation as the new subtree root
  if (parent_instance != this.scene.root) {
    if (parent_instance.parent) {
      if (parent_instance.parent.A == parent_instance) {
        parent_instance.parent.A = op_node;
      } else {
        parent_instance.parent.B = op_node;
      }
    }
  } else {
    this.scene.root = op_node;
  }

  op_node.parent = parent_instance.parent;
  parent_instance.parent = op_node;
  child_instance.parent = op_node;

  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._detachNode = function (node_key) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  // Move up the operation tree
  // to the root operation of the child group
  node_instance = this._moveUpTree(node_instance);

  if (!node_instance.parent) {
    return;
  }

  var parent = node_instance.parent;

  var grandparent = parent.parent;

  // Merge
  var other = parent.A == node_instance ? parent.B : parent.A;

  other.transform = parent.transform;
  other.interactive = parent.interactive;
  other.material = parent.material;
  other.opacity = parent.opacity;
  other.drawmode = parent.drawmode;
  other.bboxColor = parent.bboxColor;
  other.wireframeColor = parent.wireframeColor;
  other.flags = parent.flags;

  if (parent != this.scene.root) {
    if (grandparent) {
      if (grandparent.A == parent) {
        grandparent.A = other;
      } else {
        grandparent.B = other;
      }
    }
  } else {
    this.scene.root = other;
  }

  other.parent = grandparent;

  // Move down the left branch to decrease child count of the group
  while (other.A) {
    other = other.A;
  }

  other.children--;

  // Clean up
  delete node_instance.parent;

  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._setNodeGroup = function (node_key, group) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);

  if (typeof group != "undefined") {
    node_instance.group = group;
  } else {
    delete node_instance.group;
  }

  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._setNodeMaterial = function (
  node_key,
  material,
  envmap,
  smooth,
  bumpnoise,
  gauss
) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.material = material;
  node_instance.envmap = envmap;
  node_instance.smooth = smooth;

  if (bumpnoise) {
    node_instance.perlin = this._parseBumpNoise(bumpnoise);
  } else {
    node_instance.perlin = null;
  }

  node_instance.gaussian_amplitude = gauss;

  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._setNodeSolidity = function (
  node_key,
  min_solidity,
  max_solidity
) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);

  if (min_solidity < 0 || max_solidity < 0) {
    if (node_instance.solidity) {
      delete node_instance.solidity;
    }
  } else {
    node_instance.solidity = [min_solidity, max_solidity];
  }

  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._setNodeFlags = function (node_key, flags) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.flags = flags;
  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._setNodeOpacity = function (
  node_key,
  opacity
) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.opacity = opacity;

  this._sceneChanged(false);
};

Sculpteo3DViewerCommon.prototype._setNodeTransform = function (
  node_key,
  transform
) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.transform = new Sculpteo3DViewerCommonTransform3D(transform);

  this._sceneChanged(true);
};

Sculpteo3DViewerCommon.prototype._setNodeInteractive = function (
  node_key,
  enable
) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.interactive = enable;

  this._sceneChanged(false);
};

Sculpteo3DViewerCommon.prototype._setNodeDrawMode = function (node_key, mask) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.drawmode = mask;

  this._sceneChanged(false);
};

Sculpteo3DViewerCommon.prototype._setNodeBboxColor = function (
  node_key,
  r,
  g,
  b,
  a
) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.bboxColor = {
    r: r,
    g: g,
    b: b,
    a: a,
  };

  this._sceneChanged(false);
};

Sculpteo3DViewerCommon.prototype._setNodeWireframeColor = function (
  node_key,
  r,
  g,
  b,
  a
) {
  var node_instance = this.scene.instances[node_key];

  if (!node_instance) {
    return;
  }

  node_instance = this._moveUpTree(node_instance);
  node_instance.wireframeColor = {
    r: r,
    g: g,
    b: b,
    a: a,
  };

  this._sceneChanged(false);
};

Sculpteo3DViewerCommon.prototype.rayIntersectBBox = function (bbox, ro, rd) {
  /*	Var n = Math.sqrt(rd[0]*rd[0]+rd[1]*rd[1]+rd[2]*rd[2]);
	rd[0] *= 1.0 / n;
	rd[1] *= 1.0 / n;
	rd[2] *= 1.0 / n; */

  var irdx = 1.0 / rd[0];
  var irdy = 1.0 / rd[1];
  var irdz = 1.0 / rd[2];
  var sign = [irdx < 0 ? 1 : 0, irdy < 0 ? 1 : 0, irdz < 0 ? 1 : 0];

  var tmin, tmax, tymin, tymax, tzmin, tzmax;

  /*	Log("ray origin: " + ro[0] + "," + ro[1] + "," + ro[2]);
	log("ray direction: " + rd[0] + "," + rd[1] + "," + rd[2]);
	log("box min: " + bbox[0].x + "," + bbox[0].y + "," + bbox[0].z);
	log("box max: " + bbox[1].x + "," + bbox[1].y + "," + bbox[1].z); */

  tmin = (bbox[sign[0]].x - ro[0]) * irdx;
  tmax = (bbox[1 - sign[0]].x - ro[0]) * irdx;
  tymin = (bbox[sign[1]].y - ro[1]) * irdy;
  tymax = (bbox[1 - sign[1]].y - ro[1]) * irdy;

  if (tmin > tymax || tymin > tmax) {
    return;
  }

  if (tymin > tmin) {
    tmin = tymin;
  }

  if (tymax < tmax) {
    tmax = tymax;
  }

  tzmin = (bbox[sign[2]].z - ro[2]) * irdz;
  tzmax = (bbox[1 - sign[2]].z - ro[2]) * irdz;

  if (tmin > tzmax || tzmin > tmax) {
    return;
  }

  if (tzmin > tmin) {
    tmin = tzmin;
  }

  if (tzmax < tmax) {
    tmax = tzmax;
  }

  return [tmin, tmax];
};

Sculpteo3DViewerCommon.prototype.rayIntersectNode = function (
  node,
  rox,
  roy,
  roz,
  rdx,
  rdy,
  rdz
) {
  if (!node.proto.bbox) {
    return;
  }

  var itransform = node.proto.transform.x(node.transform.inverse());
  var ro = itransform.x([rox, roy, roz, 1]);
  var rd = itransform.x([rdx, rdy, rdz, 0]);

  return this.rayIntersectBBox(node.proto.bbox, ro, rd);
};

Sculpteo3DViewerCommon.prototype.rayIntersectScene = function (
  rox,
  roy,
  roz,
  rdx,
  rdy,
  rdz,
  mask
) {
  if (this.scene_flat == null) {
    this._sceneUpdate();
  }

  var nodes = this.scene_flat;

  if (!nodes) {
    return [];
  }

  var idx = [];
  var tmins = [];

  if (typeof mask == "undefined") {
    mask = 0xffffffff;
  }

  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];

    if (typeof node == "undefined") {
      continue;
    }

    var interactive = node.instance.interactive;

    for (p = node.instance.parent; p; p = p.parent) {
      interactive |= p.interactive;
    }

    if (!(interactive & mask)) {
      continue;
    }

    var t = this.rayIntersectNode(node, rox, roy, roz, rdx, rdy, rdz);

    if (t) {
      tmins[n] = t[0];
      idx.push(n);
    }
  }

  idx.sort(function (a, b) {
    return tmins[a] - tmins[b];
  });

  var ret = [];

  for (var n = 0; n < idx.length; n++) {
    ret.push(nodes[idx[n]]);
  }

  return ret;
};

// Get the nodes at a given screenspace location.
Sculpteo3DViewerCommon.prototype.nodesAtLocation = function (x, y, mask) {
  var nodes;

  if (this.nodeAtLocation) {
    var __x = ((2.0 * x) / (this.width - 1.0) - 1.0) * this.zoomx;
    var __y = ((2.0 * y) / (this.height - 1.0) - 1.0) * -this.zoomy;

    var node = this.nodeAtLocation(__x, __y);

    nodes = [];

    if (node) {
      nodes.push(node);
    }
  } else {
    var pos = this.getPositionFromXY(x, y);

    nodes = this.rayIntersectScene(
      pos[0],
      pos[1],
      pos[2],
      pos[3],
      pos[4],
      pos[5],
      mask
    );
  }

  return nodes;
};

/**
 * Get the nodes in a rectangle selection.
 * @param {Object} rect The selection rectangle
 * @param {number} rect.x: The left-upper corner position of the selection
 * @param {number} rect.y: The right-upper corner position of the selection
 * @param {number} rect.w: The width of the selection
 * @param {number} rect.h: The height of the selection
 * @todo Document the 'mask' parameter
 */
Sculpteo3DViewerCommon.prototype.nodesAtSelection = function (rect, mask) {
  var x, y;
  var xEnd = rect.x + rect.w;
  var yEnd = rect.y + rect.h;
  var nodes = [];

  for (y = rect.y; y < yEnd; ++y) {
    for (x = rect.x; x < xEnd; ++x) {
      var ns = this.nodesAtLocation(x, y, mask);

      if (ns.length > 0 && $.inArray(ns[0], nodes) == -1) {
        nodes.push(ns[0]);
      }
    }
  }

  return nodes;
};

Sculpteo3DViewerCommon.prototype.overNodes = function (x, y, mask) {
  var res = {};
  var nodes = this.nodesAtLocation(x, y, mask);

  for (var k in nodes) {
    var node = nodes[k];
    var instance = node.instance;

    res[instance.key] = instance;
  }

  return res;
};

Sculpteo3DViewerCommon.prototype.setLocal = function (local) {
  this.local = local;
  this.setUpdate(false, "abort");
};

Sculpteo3DViewerCommon.prototype.isInitialScene = function () {
  if (!this.scene) {
    return true;
  }

  if (this.scene_hash) {
    return false;
  }

  var root = this.scene.root;

  if (
    !root.operation &&
    (!root.transform || root.transform.isIdentity()) &&
    root.name == "model" &&
    root.material == "global"
  ) {
    return true;
  }

  if (
    root.operation == "union" &&
    (!root.transform || root.transform.isIdentity()) &&
    root.A.name == "root" &&
    root.A.material == "global" &&
    (!root.A.transform || root.A.transform.isIdentity()) &&
    root.B.name == "model" &&
    root.B.material == "global" &&
    (!root.B.transform || root.B.transform.isIdentity())
  ) {
    return true;
  }

  if (
    root.operation == "union" &&
    (!root.transform || root.transform.isIdentity()) &&
    root.A.operation == "union" &&
    (!root.A.transform || root.A.transform.isIdentity()) &&
    root.A.A.name == "root" &&
    root.A.A.material == "global" &&
    (!root.A.A.transform || root.A.A.transform.isIdentity()) &&
    root.A.B.name == "model" &&
    root.A.B.material == "global" &&
    (!root.A.B.transform || root.A.B.transform.isIdentity()) &&
    root.B.material == "global" &&
    (!root.B.transform || root.B.transform.isIdentity())
  ) {
    return true;
  }

  return false;
};

Sculpteo3DViewerCommon.prototype.setDesignUUID = function (uuid) {
  this.design_uuid = uuid;
};

Sculpteo3DViewerCommon.prototype.remoteRender = function () {
  if (this.local) {
    return;
  }

  if (this.isInitialScene()) {
    this._remoteRender();

    return;
  }

  // Create a scene on server
  var _this = this;
  var data;
  var map = {};
  var viewer = this;
  var models = [];
  var materials = [];
  var transforms = [];
  var flags = [];

  for (var k in viewer.scene.nodes) {
    var model = viewer.scene.nodes[k];

    if (model.uuid) {
      map[k] = models.length;
      models.push(viewer.scene.nodes[k].uuid);
    }
  }

  var scene_to_string = function (node, transform) {
    if (node.transform) {
      transform = transform.x(node.transform);
    }

    if (node.operation) {
      var A = scene_to_string(node.A, transform);
      var B = scene_to_string(node.B, transform);

      if (A && B) {
        return A + "," + B + "," + node.operation;
      } else if (A) {
        return A;
      } else if (B) {
        return B;
      } else {
        return "";
      }
    } else if (node.name) {
      if (typeof map[node.name] == "undefined") {
        return "";
      }

      var s = "" + map[node.name];

      if (1 /*Node.material != 'global'*/) {
        var i = materials.length;
        var material = _this.parseMaterial(node.material);

        if (material) {
          if (node.solidity) {
            material.solidity = {
              min: node.solidity[0],
              max: node.solidity[1],
            };
          }

          if (typeof node.envmap != "undefined") {
            material.envmap = node.envmap ? 1 : 0;
          }

          if (typeof node.smooth != "undefined") {
            material.smooth = node.smooth ? 1 : 0;
          }

          if (node.perlin) {
            material.perlin = $.extend({}, node.perlin);
          }

          if (typeof node.gaussian_amplitude != "undefined") {
            material.gaussian_amplitude = node.gaussian_amplitude;
          }

          material = _this.encodeMaterial(material);
        } else {
          material = node.material;
        }

        materials.push(material);
        s = s + ":M" + i;
      }

      if (!transform.isIdentity()) {
        var i = transforms.length;
        var t = transform.toRenderString();

        transforms.push(t);
        s = s + ":T" + i;
      }

      if (node.flags) {
        var i = flags.length;

        flags.push(node.flags);
        s = s + ":F" + i;
      }

      return s;
    } else {
      return "";
    }
  };

  data = {};

  data["scene"] = scene_to_string(this.scene.root, this.scene.root.transform);

  if (models.length) {
    data["models"] = models.join(",");
  }

  if (materials.length) {
    data["materials"] = materials.join(",");
  }

  if (transforms.length) {
    data["transforms"] = transforms.join(",");
  }

  if (flags.length) {
    data["flags"] = flags.join(",");
  }

  // Hash to avoid re-POST
  var key;
  var keys = [];

  for (key in data) {
    if (data.hasOwnProperty(key)) {
      keys.push(key);
    }
  }

  keys = keys.sort();

  var s = "";

  for (var k = 0; k < keys.length; k++) {
    s += "." + data[keys[k]];
  }

  // Log('s = ' + s);

  var scene_hash = 0,
    len = s.length;

  for (var i = 0; i < len; i++) {
    scene_hash = (scene_hash * 31 + s.charCodeAt(i)) & 0xffffffff;
  }

  // Log("hash = " + scene_hash);

  if (this.scene_hash == scene_hash) {
    // Log('scene unchanged');
    this._remoteRender();

    return;
  }

  // We still need the uuid for editinfo handling
  if (!this.design_uuid) {
    return;
  }

  sceneUrl = this.newSceneUrl + "?uuid=" + this.design_uuid;

  var that = this;

  if (this.scene_timeout) {
    clearTimeout(this.scene_timeout);
  }

  this.scene_timeout = setTimeout(function () {
    $.post(sceneUrl, data, function (ret) {
      // Log('new_scene, ret='+ret);
      that.design_uuid = ret;
      that.render_cache = false;
      that.scene_hash = scene_hash;
      that._remoteRender();
    });
  }, 100);
};

Sculpteo3DViewerCommon.prototype.getSnapshotUrl = function (
  width,
  height,
  quality
) {
  if (this.render_width > 0 && this.render_height > 0) {
    while (width > this.render_width || height > this.render_height) {
      width = width >> 1;
      height = height >> 1;
    }
  }

  var viewer_width = this.width;
  var viewer_height = this.height;
  var imageUrl = this.renderurl;

  var envmap = this.envmap ? "&envmap=1" : "";

  if (
    this.global_material &&
    typeof this.global_material.roughness !== "undefined"
  ) {
    envmap = "&envmap=2";
  }

  imageUrl += "?uuid=" + this.design_uuid;
  imageUrl +=
    "&width=" +
    width +
    "&height=" +
    height +
    "&zoom=" +
    this.zoom +
    "&rotq=" +
    this.rotq.w +
    "," +
    this.rotq.x +
    "," +
    this.rotq.y +
    "," +
    this.rotq.z +
    "&pan=" +
    this.pan_x +
    "," +
    this.pan_y +
    envmap +
    (this.use_perspective
      ? "&perspOps=" +
        this.cameraFov +
        "," +
        this.cameraZ +
        "," +
        this.nearVal +
        "," +
        this.farVal
      : "") +
    "&ar=1.0&options=";

  if (this.wireframe) {
    imageUrl += "wireframe";
  } else if (
    this.sliced &&
    this.sliced[0] != -1.0 &&
    this.sliced[1] != -1.0 &&
    this.sliced[2] != -1.0
  ) {
    imageUrl += "raytrace=2";
    imageUrl += ",vsdx=" + this.sliced[0];
    imageUrl += ",vsdy=" + this.sliced[1];
    imageUrl += ",vsdz=" + this.sliced[2];
    imageUrl += ",translucency=2000000,vam,fp,sa";
  } else {
    imageUrl += "raytrace";
  }

  if (this.pointcloud) {
    imageUrl += ",pointcloud";
  }

  if (this.material) {
    imageUrl += ",material=" + this.material;
  }

  if (this.orientation) {
    imageUrl += ",orientation";
  }

  if (this.issues) {
    imageUrl += ",issues=" + this.issues;
  }

  if (this.selectedfaces) {
    imageUrl += ",selected_faces";
  }

  if (this.smooth_normals) {
    imageUrl += ",sn";
  }

  if (this.translucency) {
    imageUrl += ",translucency=" + this.translucency;
  }

  if (this.perlin_val) {
    if (this.perlin_val.amplitude > 0.0) {
      imageUrl += ",pa=" + this.perlin_val.amplitude / Math.sqrt(this.zoom);
    }

    if (
      this.perlin_val.scale_x > 0.0 ||
      this.perlin_val.scale_y > 0.0 ||
      this.perlin_val.scale_z > 0.0
    ) {
      if (
        this.perlin_val.scale_y == this.perlin_val.scale_x &&
        this.perlin_val.scale_z == this.perlin_val.scale_x
      ) {
        imageUrl += ",ps=" + this.perlin_val.scale_x;
      } else {
        imageUrl +=
          ",psx=" +
          this.perlin_val.scale_x +
          ",psy=" +
          this.perlin_val.scale_y +
          ",psz=" +
          this.perlin_val.scale_z;
      }
    }
  }

  if (this.gauss_val) {
    imageUrl += ",ga=" + this.gauss_val;
  }

  if (this.solidity) {
    imageUrl += ",seuilSoliditeBas=" + this.solidity[0];
    imageUrl += ",seuilSoliditeHaut=" + this.solidity[1];
  }

  if (this.patch_render == 1 && quality == 2) {
    if (this.patch_fill_type) {
      imageUrl += ",fill_type=" + this.patch_fill_type;
    }
    if (this.patch_width) {
      imageUrl += ",p_w=" + this.patch_width;
    }
    if (this.patch_height) {
      imageUrl += ",p_h=" + this.patch_height;
    }
    if (this.patch_frequency) {
      imageUrl += "&frequency=" + this.patch_frequency;
    }
    imageUrl += "&patch_render=" + this.patch_render;
  }

  if (!this.render_cache) {
    date = new Date();
    imageUrl += "&nocache=" + date.getTime();
  }

  imageUrl += "&quality=" + (this.remote_quality || quality);

  return imageUrl;
};

Sculpteo3DViewerCommon.prototype.resizeViewerFrame = function (
  viewerId,
  width,
  height
) {
  this.sculpteo3dviewer.css("width", width + "px");
  this.sculpteo3dviewer.css("height", height + "px");
  this.jself.css("width", width + "px");
  this.jself.css("height", height + "px");
  this.$canvas.css("width", width + "px");
  this.$canvas.css("height", height + "px");
  this.$imageDiv.css("width", width + "px");
  this.$imageDiv.css("height", height + "px");
  if (this.ui && this.ui.root) {
    this.ui.root.frame.w = width;
    this.ui.root.frame.h = height;
  }
};

Sculpteo3DViewerCommon.prototype.createViewerFrame = function (
  jself,
  viewerId,
  options,
  width,
  height,
  klass,
  extra_html
) {
  var html =
    '<div class="' +
    klass +
    ' relative" \
	 style="width: ' +
    width +
    "px; height: " +
    height +
    'px; display: block; margin-left: auto; margin-right: auto;" \
	 id="Sculpteo3DViewer' +
    viewerId +
    '">				\
	<img class="Sculpteo3DViewerBackgroundImage hidden" style="left: 0; top: 0; width:' +
    width +
    "px;height:" +
    height +
    'px;"></img> \
	<div class="Sculpteo3DViewerGrid absolute hidden"></div>	\
	<canvas								\
	id="Sculpteo3DViewerCanvas' +
    viewerId +
    '" class="Sculpteo3DViewerCanvas absolute"						\
	style="top: 0px; left: 0px;"					\
	width="' +
    width +
    '"						\
	height="' +
    height +
    '"						\
	>									\
	</canvas>								\
	<div class="Sculpteo3DViewerImageDiv absolute" style="left: 0px; top: 0px; width:' +
    width +
    "px;height:" +
    height +
    'px; overflow:hidden;" ></div> \
	<div class="Sculpteo3DViewerRuler absolute hidden">		\
		<div class="Sculpteo3DViewerRuler_metric_text absolute"></div> \
		<div class="Sculpteo3DViewerRuler_imperial_text absolute"></div> \
		<div class="Sculpteo3DViewerRuler_metric_start absolute" style="width:1px; height: 6px; background-color: #000000;"></div> \
		<div class="Sculpteo3DViewerRuler_metric_length absolute" style="width:1px; height: 1px; background-color: #000000;"></div> \
		<div class="Sculpteo3DViewerRuler_metric_end absolute" style="width:1px; height: 6px; background-color: #000000;"></div> \
		<div class="Sculpteo3DViewerRuler_imperial_start absolute" style="width:1px; height: 6px; background-color: #000000;"></div> \
		<div class="Sculpteo3DViewerRuler_imperial_length absolute" style="width:1px; height: 1px; background-color: #000000;"></div> \
		<div class="Sculpteo3DViewerRuler_imperial_end absolute" style="width:1px; height: 6px; background-color: #000000;"></div> \
	</div>								' +
    (extra_html ? extra_html : "") +
    "</div>";

  jself.html(html);
  this.$canvas = $(".Sculpteo3DViewerCanvas", jself);
  this.$imageDiv = $(".Sculpteo3DViewerImageDiv", jself);
  this.jImageDiv = document.getElementsByClassName(
    "Sculpteo3DViewerImageDiv"
  )[0];
  this.$ruler = $(".Sculpteo3DViewerRuler", jself);
  addViewerSelect(jself, viewerId, options);
};

Sculpteo3DViewerCommon.prototype.updateProceduralMesh = function (node, name) {
  var fn = node.proc;

  mesh = fn();

  if (mesh === false) {
    return;
  }

  if (!mesh.material) {
    mesh.material = [];
  }

  mesh.material_count = mesh.material.length;
  mesh.vertex_count = mesh.v.length;
  mesh.face_count = mesh.f.length;

  if (!mesh.scale) {
    mesh.scale = 2.0;
  }

  if (!mesh.center_x) {
    mesh.center_x = 0.0;
  }

  if (!mesh.center_y) {
    mesh.center_y = 0.0;
  }

  if (!mesh.center_z) {
    mesh.center_z = 0.0;
  }

  if (!mesh.minpx) {
    var i;
    var minpx, minpy, minpz, maxpx, maxpy, maxpz;

    if (!mesh.vertex_count) {
      minpx = minpy = minpz = maxpx = maxpy = maxpz = 0.0;
    } else {
      minpx = maxpx = mesh.v[0];
      minpy = maxpy = mesh.v[1];
      minpz = maxpz = mesh.v[2];
    }

    for (var i = 1; i < mesh.vertex_count; i++) {
      if (mesh.v[3 * i + 0] < minpx) {
        minpx = mesh.v[3 * i + 0];
      }

      if (mesh.v[3 * i + 0] > maxpx) {
        maxpx = mesh.v[3 * i + 0];
      }

      if (mesh.v[3 * i + 1] < minpy) {
        minpy = mesh.v[3 * i + 1];
      }

      if (mesh.v[3 * i + 1] > maxpy) {
        maxpy = mesh.v[3 * i + 1];
      }

      if (mesh.v[3 * i + 2] < minpz) {
        minpz = mesh.v[3 * i + 2];
      }

      if (mesh.v[3 * i + 2] > maxpz) {
        maxpz = mesh.v[3 * i + 2];
      }
    }

    mesh.minpx = minpx;
    mesh.minpy = minpy;
    mesh.minpz = minpz;
    mesh.maxpx = maxpx;
    mesh.maxpy = maxpy;
    mesh.maxpz = maxpz;
  }

  var that = this;
  var model = {
    mesh: mesh,
    proc: fn,
  };

  if (!this.scene.nodes[name]) {
    this.scene.nodes[name] = new Sculpteo3DViewerCommonNode(
      undefined,
      Sculpteo3DViewerCommonTransform3D.identity
    );
    this.scene.nodes[name].name = name;
  }

  $.extend(
    model,
    this.buildModel(mesh, function () {
      that.__loadModelOnReady.call(that, model, name);
    })
  );
};

Sculpteo3DViewerCommon.prototype.updateScene = function () {
  if (this.scene_flat == null) {
    this._sceneUpdate();
  }

  for (var k = 0; k < this.scene_flat.length; k++) {
    if (this.scene_flat[k].proto.proc) {
      this.updateProceduralMesh(
        this.scene_flat[k].proto,
        this.scene_flat[k].proto.name
      );
    }
  }
};

Sculpteo3DViewerCommon.prototype.startRenderLoop = function () {
  var raf =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame;

  var viewer = this;

  this.lastFrame = +new Date();

  if (raf) {
    this.tick = true;
    var loop = function (timestamp) {
      try {
        viewer.updateScene(timestamp);
        viewer.drawScene(timestamp - viewer.lastFrame);
      } catch (e) {
        log("ERROR: " + e);
      }

      viewer.lastFrame = timestamp;

      if (viewer.tick) {
        raf(loop, viewer.$canvas[0]);
      }
    };

    loop(+new Date());
  } else {
    this.tick = setInterval(function (delta) {
      var now = +new Date();

      viewer.updateScene(now);
      viewer.drawScene(now - viewer.lastFrame);
      viewer.lastFrame = now;
    }, 16);
  }

  // This.tick = setInterval(function() { viewer.drawScene(); }, 1000.0 / 30.0);
  // This.tick = setInterval(function() { viewer.drawScene(); }, 1.0);
};

Sculpteo3DViewerCommon.prototype.stopRenderLoop = function () {
  if (typeof this.tick == "undefined") {
    return;
  }

  var raf =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame;
  var caf = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

  if (raf) {
    this.tick = false;
  } else {
    clearInterval(this.tick);
  }
};

Sculpteo3DViewerCommon.prototype.log = function (msg) {
  log(msg);
};

Sculpteo3DViewerCommon.prototype.cleanUp = function () {
  if (this.current_focus) {
    var old_focus_key = this.current_focus.instance.key;

    delete this.current_focus;
    delete this.current_moveable;
    this.postEvent("node", old_focus_key, "blur");
  }

  if (this.control_timeout) {
    clearTimeout(this.control_timeout);
  }

  clearTimeout(this.timeout);
  clearTimeout(this.timeout2);
  this.stopRenderLoop();

  if (this.sculpteo3dviewer) {
    this.sculpteo3dviewer.Sculpteo3DViewer().clearStatusMessage();
  }
};

Sculpteo3DViewerCommon.ISSUES_NON_MANIFOLD_VERTICES = 1 << 0;
Sculpteo3DViewerCommon.ISSUES_NON_MANIFOLD_EDGES = 1 << 1;
Sculpteo3DViewerCommon.ISSUES_BORDER_EDGES = 1 << 2;
Sculpteo3DViewerCommon.ISSUES_INTERSECTING_FACES = 1 << 3;
Sculpteo3DViewerCommon.ISSUES_OVERHANG_VERTICES = 1 << 4;
